/* eslint-disable func-names */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
// import {parse, stringify} from 'flatted/esm';
import Vue from 'vue';
var pjson = require('../package.json');
var exploreSqlPostgres = `select DISTINCT c.table_catalog, c.table_schema, c.table_name, c.column_name, c.data_type, s1.seq_scan,
split_part(idx.idx_column, ',', 1) as idx_column,
log(case when s1.seq_scan > 0 then s1.seq_scan else 1 end) as seq_ratio_log,
case when t.table_type != 'VIEW' THEN 1 ELSE 0 END AS is_table
from
information_schema.columns as c left join
information_schema.tables as t on c.table_name = t.table_name and 
                                  c.table_schema = t.table_schema and c.table_catalog = t.table_catalog left join
pg_catalog.pg_stat_all_tables as s1 on c.table_schema = s1.schemaname and
  c.table_name = s1.relname left join
(select
i1.schemaname, i1.tablename, i1.indexname,
replace(split_part(i1.indexdef, '(', 2), ')', '') as idx_column, i2.idx_scan
from
pg_catalog.pg_indexes as i1 inner join
pg_catalog.pg_stat_all_indexes as i2 on i1.schemaname = i2.schemaname and
  i1.tablename  = i2.relname and i1.indexname = i2.indexrelname inner join
(select concat(schemaname, relname) as join_on, max(idx_scan) as idx_scan
from pg_catalog.pg_stat_all_indexes
group by 1) as ms on concat(i2.schemaname, i2.relname) = ms.join_on
  and i2.idx_scan = ms.idx_scan) as idx on c.table_schema = idx.schemaname and
  c.table_name = idx.tablename
where c.table_schema not in ('pg_catalog', 'information_schema')
order by c.table_catalog, c.table_schema, c.table_name, c.column_name
LIMIT 10000
;`
var exploreSqlMySQL = `
select c.table_catalog as "table_catalog", c.table_schema as "table_schema", c.table_name as "table_name", 
c.column_name as "column_name", c.data_type as "data_type", 0 as seq_scan,
null as idx_column, 0 as seq_ratio_log,
case when t.table_type != 'VIEW' THEN 1 ELSE 0 END AS is_table
from
information_schema.columns as c left join
information_schema.tables as t on c.table_name = t.table_name and 
                                  c.table_schema = t.table_schema and c.table_catalog = t.table_catalog
where c.table_schema not in ('information_schema', 'mysql', 'performance_schema', 'sys')
order by c.table_catalog, c.table_schema, c.table_name, c.column_name
LIMIT 10000
`

var exploreSqlMssql = `select TOP 10000 TABLE_CATALOG as table_catalog, TABLE_SCHEMA as table_schema, TABLE_NAME as table_name,
COLUMN_NAME as column_name, DATA_TYPE as data_type, 0 as seq_scan,
null as idx_column, 0 as seq_ratio_log
from
information_schema.columns as c
order by TABLE_CATALOG, TABLE_SCHEMA, TABLE_NAME, COLUMN_NAME
`

var exploreSqlSnowflake = `select c.TABLE_CATALOG as "table_catalog", c.TABLE_SCHEMA as "table_schema", c.TABLE_NAME as "table_name",
c.COLUMN_NAME as "column_name", c.DATA_TYPE as "data_type", 0 as "seq_scan",
null as "idx_column", 0 as "seq_ratio_log",
case when t.TABLE_TYPE != 'VIEW' THEN 1 ELSE 0 END AS "is_table"
from
information_schema.columns as c left join
information_schema.tables as t on c.table_name = t.table_name and 
                                  c.table_schema = t.table_schema and c.table_catalog = t.table_catalog
where c.table_schema not in ('INFORMATION_SCHEMA')
order by c.TABLE_CATALOG, c.TABLE_SCHEMA, c.TABLE_NAME, c.COLUMN_NAME
LIMIT 10000
;`

export const store = {
    state: {
        showDebugStuffNow: false, //DO set this
        showDebugStuff: false, //DONT set this
        forceProd: false, //seekwell.io API
        forceProdRunner: false, //api.seekwell.io API
        isMac: navigator.platform.toUpperCase().indexOf('MAC') >= 0,
        allRows: false,
        showHelp: false,
        hideHelp: false,
        noBlocks: false,
        exploreRowLimit: 10000,
        cssProps: {
            '--cm-line-number-color': 'rgba(0, 0, 0, 0.25)',
        },
        browsing: {
            active: 'schemas',
            search: '',
            schema: '',
            table: '',
            column: '',
            stats: {},
            detailsLoading: false,
            results: {},
        },
        viewNumber: 1,
        itemsPerPage: 100,
        viewAll: false,
        firstBlockGetLimit: 40,
        maxBlocksToGet: 3500,
        doLogin: true,
        blockListOpen: false,
        defaultSource: false,
        scrollingHistory: false,
        dfObjects: [],
        integration: {
            'hubspot': {
                'ok': false
            },
            'zendesk': {
                'ok': false
            },
            'servicenow': {
                'ok': false
            },
            'outreach': {
                'ok': false
            },
            'gainsight': {
                'ok': false
            },
            'mailchimp': {
                'ok': false
            },
            'customerio': {
                'ok': false
            },
            'activecampaign': {
                'ok': false
            },
            'pipedrive': {
                'ok': false
            },
            'zoho': {
                'ok': false
            },
            'linkedinads': {
                'ok': false
            },
            'front': {
                'ok': false
            },
            'drift': {
                'ok': false
            }
        },
        gotApps: false,
        gotIntercom: false,
        gotHubspot: false,
        gotDriftFields: false,
        gotSfdc: false,
        gotWorkbooks: false,
        gotSheets: true,
        errLineNum: -1,
        inviteId: false,
        invites: [''],
        runView: 0,
        searching: false,
        tableExpanded: false,
        cmAutofocus: false,
        showCm: true,
        dfHasJson: false,
        currentRunTime: 0,
        codeTimerInterval: 0,
        defaultAnalyticsProps: {
            version: pjson.version,
            platform: 'web'
        },
        exploreSqlDict: {
            'mysql': exploreSqlMySQL,
            'postgres': exploreSqlPostgres,
            'redshift': exploreSqlPostgres,
            'mssql': exploreSqlMssql,
            'snowflake': exploreSqlSnowflake
        },
        runViews: [
            {}, //dummy placeholder so view numbers start at 1
            {
                label: '5050',
                blockContainer: {
                    minHeight: '460px'
                },
                cm: { height: '440px' },
                table: { height: '600px' },
            },
            {
                label: 'zenCode',
                cmHeight: '100',
                blockContainer: {
                    minHeight: 'calc(100vh - 120px)',
                },
                cm: { height: 'calc(100vh - 120px)' },
                table: { height: '600px' },
            },
            {
                label: 'bigTable',
                cmHeight: '100',
                blockContainer: {
                    minHeight: '150px',
                    display: 'none'
                },
                table: { height: 'calc(100vh - 120px)' },
            },
            {
                label: 'bigChart',
                cmHeight: '100',
                blockContainer: {
                    minHeight: '150px',
                    display: 'none'
                },
                table: { height: 'calc(100vh - 120px)' },
            },
            {
                label: '5050',
                blockContainer: {
                    minHeight: '460px'
                },
                cm: { height: '440px' },
                table: { height: '600px' },
            },
        ],
        intervals: [
            { value: 'hourly', text: 'Hourly' },
            { value: 'daily', text: 'Daily' },
            { value: 'weekly', text: 'Weekly' },
            // {value: 'monthly', text: 'Monthly'},
            { value: 'fivemin', text: '5 minutes' },
        ],

        loading: false,
        sessionId: false,
        editor: false,
        editableDetails: {
            reminder: false,
            comments: [],
            tags: [],
        },
        joinSuggestions: [],
        blockTemplate: {
            title: '',
            doc: {
                layout: []
            },
            set: {
                sql: false,
                json: false,
                type: 'sql', //sql, json, explore
                filters: [],
                userEdit: false,
            },
            story: {
                json: false,
                html: '',
                htmlPreview: '',
                blocks: []
            },
            form: {
                submits: [],
                approvalType: {
                    label: 'No approval required',
                    value: 'noApproval',
                },
                hasLookup: false,
                performedLookup: false,
                lookups: false,
                justSubmitted: false,
            },
            sheetSyncs: {}, //row level sync triggered by the addon
            editables: {
                pending: {},
                running: {},
            },
            currentRunTime: 0,
            codeTimerInterval: 0,
            public: false,
            favorite: false,
            uuid: false,
            cellType: 'sql', //really more like "block type"
            destination: {
                ss_id: false,
                name: false,
                sheet: false,
                sheetsAppend: false,
                omitColumnNames: false,
                cell: 'A1',
                type: 'sheets',
                channel: '',
                emails: '',
                emailSource: { icon: 'mdi-eraser', text: 'Enter manually', value: 'manual' },
                emailSourceBlock: false,
                emailSourceColumn: false,
                emailOverrideSender: false,
                table: false,
                workbookId: false,
                gdWorkbookId: false,
                excelSheetName: '',
                excelCell: 'A1',
                excelLocation: 'googledrive',
                block: false,
                intercom: {
                    role: 'user',
                    key: 'email'
                },
                zendesk: {
                    obj: 'user',
                    key: 'external_id'
                },
                sfdc: {
                    object: false,
                    operation: false,
                },
                hubspot: {
                },
                servicenow: {
                    object: false,
                },
                mailchimp: {
                    object: false,
                },
                outreach: {
                    obj: false,
                },
                blueshift: {
                    obj: false,
                },
                gainsight: {
                    object: false,
                },
                customerio: {
                    object: false,
                },
                activecampaign: {
                    object: false,
                },
                pipedrive: {
                    object: false,
                },
                zoho: {
                    object: false,
                },
                linkedinads: {
                    object: false,
                    operation: false
                },
                front: {
                    object: false,
                },
                drift: {
                    object: false,
                },
                facebook: {
                    account_id: false,
                    createAudience: false
                },
                database: {
                    operation: false,
                    table: '',
                },
                msteams: {
                    teams: '',
                    channel: '',
                    teamName: '',
                    channelName: '',
                    channelList: [],
                },
                close: {
                    obj: false
                },
                mapping: {
                    columns: [{ column: false, destination: {}, hovering: false }],
                    ok: false
                }
            },
            manualDestination:
                `{
    "type": "sheets",
    "ss_id": "GET_THIS_FROM_SHEET_URL",
    "sheet": "Sheet1",
    "serviceAccount": true,
    "cell": "A1",
    "sheetsAppend": false,
    "omitColumnNames": false
}`,
            source: {
                name: false,
                uuid: false,
                type: 'sql',
                meta: false,
            },
            repeat: {
                period: false,
                minutesPast: '',
                runTime: false,
                dayOfWeek: 'monday',
                dayOfMonth: '',
            },
            pivot: {
                active: false,
                origHeaders: false,
                index: [],
                values: {},
                columns: {},
                aggfunc: [],
                fill_value: 0,
                margins: false,
                margins_name: 'Total',
            },
            code: '',
            python: {
                dfNames: [],
            },
            ast: false,
            params: [],
            trigger: {
                type: 'hasRows',
                blockId: false,
                js: '',
                column: false,
            },
            tags: [],
            options: {
                clearColumns: true,
                clearSheet: false,
            },
            viz: {
                type: 'bar',
                chartJsOptions: {
                    maintainAspectRatio: false,
                    responsive: true,
                    animation: {
                        duration: 0
                    },
                    hover: {
                        animationDuration: 0
                    },
                    responsiveAnimationDuration: 0,
                    legend: { display: true, position: 'top' },
                },
                title: '',
            },
            viewedOn: moment.unix(moment()).utc()._i, //really updated on
            deleted: false,
            queryBuilder: false, //created thru SeekWell UI
            setQuery: '',
            tables: { syncs: [], filters: [] },
            setQueryThings: [],
            setQueryFilters: [],
            results: {
                meta: {
                    rows: -1,
                    runTime: 0,
                    lastRun: false,
                    runs: 0,
                },
                rows: [],
                headers: [],
                stats: {},
                tableOptions: {
                    sortBy: ''
                }
            }
        },
        shareUrl: '',
        iconLookUp: {
            number: 'mdi-pound',
            int: 'mdi-pound',
            'float64': 'mdi-pound',
            'int64': 'mdi-pound',
            float: 'mdi-pound',
            string: 'mdi-format-text',
            object: 'mdi-format-text',
            str: 'mdi-format-text',
            dict: 'mdi-json',
            date: 'mdi-calendar-blank',
            datetime: 'mdi-calendar-blank',
            'datetime64[ns]': 'mdi-calendar-blank',
            time: 'mdi-calendar-blank',
            sum: 'mdi-pound',
            count: 'mdi-pound',
        },
        block: function () { return this.blockTemplate },
        vizOptions: {
            types: [
                { icon: 'mdi-chart-bar', label: 'Bar', value: 'bar' },
                { icon: 'mdi-chart-line', label: 'Line', value: 'line' },
                // {icon: 'mdi-numeric-8-box-outline', label: 'Numbers', value: 'numbers'},
            ],
            legends: [
                { icon: 'mdi-eye-off-outline', label: 'No legend', value: 'none', display: false, position: 'top' },
                { icon: 'mdi-arrow-up', label: 'Legend Top', value: 'top', display: true, position: 'top' },
                { icon: 'mdi-arrow-down', label: 'Legend Bottom', value: 'bottom', display: true, position: 'bottom' },
            ],
        },
        blockHistory: [],
        blockHistoryPosition: -1,
        destinationTypes: [
            { icon: 'mdi-google-spreadsheet', text: 'Sheets', value: 'sheets' },
            { icon: 'mdi-file-excel-box', text: 'Excel', value: 'excel' },
            { icon: 'mdi-slack', text: 'Slack', value: 'slack', story: true, },
            { icon: 'mdi-email', text: 'Email', value: 'email', story: true, },
            { icon: 'mdi-view-grid', text: 'Block', value: 'block', story: true, },
            { icon: 'mdi-database', text: 'Database', value: 'database', story: true, },
            { icon: 'mdi-bullhorn', text: 'Intercom', value: 'intercom', story: false, },
            { icon: 'mdi-salesforce', text: 'Salesforce', value: 'sfdc', story: false, },
            { icon: 'mdi-alpha-z-circle', text: 'Zendesk', value: 'zendesk', story: false, },
            { icon: 'mdi-hubspot', text: 'HubSpot', value: 'hubspot', story: false, },
            { icon: 'mdi-email-sync', text: 'Outreach', value: 'outreach', story: false, },
            { icon: 'mdi-email-sync', text: 'Zoho', value: 'zoho', story: false, },
            { icon: 'mdi-linkedin-box', text: 'LinkedIn Ads', value: 'linkedinAds', story: false, },
            { icon: 'mdi-card-account-mail', text: 'Mailchimp', value: 'mailchimp', story: false, },
            { icon: 'mdi-face-agent', text: 'ServiceNow', value: 'servicenow', story: false, },
            { icon: 'mdi-code-json', text: 'Manual', value: 'manual', story: false, },
            { icon: 'mdi-parking', text: 'Pipedrive', value: 'pipedrive', story: false, },
            { icon: 'mdi-source-fork', text: 'Front', value: 'front', story: false, },
            { icon: 'mdi-microsoft-teams', text: 'MS Teams', value: 'msteams', story: true },
            //{ icon: 'mdi-account-circle-outline', text: 'CustomerIO', value: 'customerio', story: false, },
            { icon: ' mdi-flash', text: 'Drift', value: 'drift', story: false, }
            // { icon: 'mdi-facebook', text: 'Facebook', value: 'facebook', story: false, },
            // { icon: 'mdi-sync', text: 'Sync', value: 'sync' },
        ],
        triggerTypes: [
            { icon: 'mdi-table', text: 'Block has rows', value: 'hasRows' },
            { icon: 'mdi-delta', text: 'Results changed (1 row only)', value: 'valueChanged' },
            { icon: 'mdi-delta', text: 'Results changed by (1 row only)', value: 'valueChangedBy' },
        ],
        excelLocations: [
            { icon: 'google-drive', text: 'Google Drive', value: 'googledrive' },
            // { icon: '', text: 'OneDrive', value: 'onedrive' },
        ],
        appendTypes: [
            { icon: 'mdi-eraser', text: 'Replace rows', value: 'replace' },
            { icon: 'mdi-plus', text: 'Append rows', value: 'append' },
        ],
        omitTypes: [
            { icon: 'mdi-plus', text: 'Include column names', value: false },
            { icon: 'mdi-minus', text: 'Omit column names', value: true },
        ],
        emailSourceTypes: [
            { icon: 'mdi-pencil', text: 'Enter manually', value: 'manual' },
            { icon: 'mdi-format-list-bulleted', text: 'Use a block', value: 'block' },
        ],
        newBlocks: [],
        noAccess: false,
        blocks: {},
        trash: {},
        gettingTrash: false,
        blockResults: [],
        blockAuthorCounts: {},
        authorList: [],
        schedules: {},
        gotBlocks: false,
        gotBlocks2: false,
        gotBlock: false,
        gotFeed: false,
        gotIntegrations: false,
        integrations: {
        },
        integrationCatalog: [],
        feed: [],
        feedResults: [],
        autoImport: {},
        autoImportTemplate: {
            type: 'autoImportToSheets',
            success: false,
            schedule: false,
            ss_id: false,
            spreadSheetMetadata: {
                sheets: []
            },
            destination: {
                uuid: false,
            },
            source: {
                uuid: false,
            },
            schema: '',
            running: false,
            repeat: {
                period: 'daily'
            },
            gettingTables: false,
            tables: []
        },
        runningNowIds: [], //list of blocks currently running
        canceledRunIds: [], //list of blocks currently running
        gotSchedules: false,
        gettingBlock: false,
        gotSchedules: false,
        gotSources: false,
        tableLoading: false,
        activeQueue: 0,
        editableDetailsShell: {
            reminder: false,
            comments: [],
            tags: [],
        },
        code: '',
        editableDetailsAll: [],
        sources: [],
        allSources: [],
        addingSource: false,
        destinations: {
            spreadSheets: [],
            sheets: [],
            spreadSheetMetadata: {},
            slack: {},
            msteams: {
                ok: false,
                data: []

            },
            workbooks: [],
            intercom: [],
            sfdc: {
                ok: false,
            },
            hubspot: {
            },
            zoho: {
                ok: false,
            },
            outreach: {
                accounts: [
                    { name: 'id', type: 'string' },
                    { name: 'customId', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'domain', type: 'string' },
                    { name: 'externalSource', type: 'string' },
                    { name: 'followers', type: 'integer' },
                    { name: 'foundedAt', type: 'date-time' },
                    { name: 'industry', type: 'string' },
                    { name: 'linkedInEmployees', type: 'integer' },
                    { name: 'linkedInUrl', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'named', type: 'boolean' },
                    { name: 'naturalName', type: 'string' },
                    { name: 'numberOfEmployees', type: 'integer' },
                    { name: 'websiteUrl', type: 'string' },
                    { name: 'companyType', type: 'string' },
                    { name: 'buyerIntentScore', type: 'float' },
                    { name: 'custom1', type: 'string' },
                    { name: 'custom2', type: 'string' },
                    { name: 'custom3', type: 'string' },
                    { name: 'custom4', type: 'string' },
                    { name: 'custom5', type: 'string' },
                    { name: 'custom6', type: 'string' },
                    { name: 'custom7', type: 'string' },
                    { name: 'custom8', type: 'string' },
                    { name: 'custom9', type: 'string' },
                    { name: 'custom10', type: 'string' },
                ],
                prospects: [
                    { name: 'addedAt', type: 'date-time' },
                    { name: 'addressCity', type: 'string' },
                    { name: 'addressCountry', type: 'string' },
                    { name: 'addressState', type: 'string' },
                    { name: 'addressStreet', type: 'string' },
                    { name: 'addressStreet2', type: 'string' },
                    { name: 'addressZip', type: 'string' },
                    { name: 'angelListUrl', type: 'string' },
                    { name: 'availableAt', type: 'date-time' },
                    { name: 'callOptedOut', type: 'boolean' },
                    { name: 'callsOptStatus', type: 'string' },
                    { name: 'callsOptedAt', type: 'date-time' },
                    { name: 'campaignName', type: 'string' },
                    { name: 'clickCount', type: 'integer' },
                    { name: 'company', type: 'string' },
                    { name: 'contactHistogram', type: 'object' },
                    { name: 'createdAt', type: 'date-time' },
                    { name: 'custom1', type: 'string' },
                    { name: 'custom2', type: 'string' },
                    { name: 'custom3', type: 'string' },
                    { name: 'custom4', type: 'string' },
                    { name: 'custom5', type: 'string' },
                    { name: 'custom6', type: 'string' },
                    { name: 'custom7', type: 'string' },
                    { name: 'custom8', type: 'string' },
                    { name: 'custom9', type: 'string' },
                    { name: 'custom10', type: 'string' },
                    { name: 'dateOfBirth', type: 'date' },
                    { name: 'degree', type: 'string' },
                    { name: 'emailOptedOut', type: 'boolean' },
                    { name: 'emails', type: 'email' },
                    { name: 'emailsOptStatus', type: 'string' },
                    { name: 'emailsOptedAt', type: 'date-time' },
                    { name: 'engagedAt', type: 'date-time' },
                    { name: 'engagedScore', type: 'float' },
                    { name: 'eventName', type: 'string' },
                    { name: 'externalId', type: 'string' },
                    { name: 'externalOwner', type: 'string' },
                    { name: 'externalSource', type: 'string' },
                    { name: 'facebookUrl', type: 'string' },
                    { name: 'firstName', type: 'string' },
                    { name: 'gender', type: 'string' },
                    { name: 'githubUrl', type: 'string' },
                    { name: 'githubUsername', type: 'string' },
                    { name: 'googlePlusUrl', type: 'string' },
                    { name: 'graduationDate', type: 'date' },
                    { name: 'homePhones', type: 'string' },
                    { name: 'jobStartDate', type: 'date' },
                    { name: 'lastName', type: 'string' },
                    { name: 'linkedInConnections', type: 'integer' },
                    { name: 'linkedInId', type: 'string' },
                    { name: 'linkedInSlug', type: 'string' },
                    { name: 'linkedInUrl', type: 'string' },
                    { name: 'middleName', type: 'string' },
                    { name: 'mobilePhones', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'nickname', type: 'string' },
                    { name: 'occupation', type: 'string' },
                    { name: 'openCount', type: 'integer' },
                    { name: 'optedOut', type: 'boolean' },
                    { name: 'optedOutAt', type: 'date-time' },
                    { name: 'otherPhones', type: 'string' },
                    { name: 'personalNote1', type: 'string' },
                    { name: 'personalNote2', type: 'string' },
                    { name: 'preferredContact', type: 'string' },
                    { name: 'quoraUrl', type: 'string' },
                    { name: 'region', type: 'string' },
                    { name: 'replyCount', type: 'integer' },
                    { name: 'school', type: 'string' },
                    { name: 'score', type: 'float' },
                    { name: 'sharingTeamId', type: 'string' },
                    { name: 'source', type: 'string' },
                    { name: 'specialties', type: 'string' },
                    { name: 'stackOverflowId', type: 'string' },
                    { name: 'stackOverflowUrl', type: 'string' },
                    { name: 'tags', type: 'string' },
                    { name: 'timeZone', type: 'string' },
                    { name: 'timeZoneIana', type: 'string' },
                    { name: 'timeZoneInferred', type: 'string' },
                    { name: 'title', type: 'string' },
                    { name: 'touchedAt', type: 'date-time' },
                    { name: 'trashedAt', type: 'date-time' },
                    { name: 'twitterUrl', type: 'string' },
                    { name: 'twitterUsername', type: 'string' },
                    { name: 'updatedAt', type: 'date-time' },
                    { name: 'voipPhones', type: 'string' },
                    { name: 'websiteUrl1', type: 'string' },
                    { name: 'websiteUrl2', type: 'string' },
                    { name: 'websiteUrl3', type: 'string' },
                    { name: 'workPhones', type: 'string' },
                ],
                calls: [
                    { name: 'answeredAt', type: 'date-time' },
                    { name: 'completedAt', type: 'date-time' },
                    { name: 'createdAt', type: 'date-time' },
                    { name: 'dialedAt', type: 'date-time' },
                    { name: 'direction', type: 'string' },
                    { name: 'externalVendor', type: 'string' },
                    { name: 'from', type: 'string' },
                    { name: 'note', type: 'string' },
                    { name: 'outcome', type: 'string' },
                    { name: 'recordingUrl', type: 'string' },
                    { name: 'returnedAt', type: 'date-time' },
                    { name: 'sequenceAction', type: 'string' },
                    { name: 'shouldRecordCall', type: 'boolean' },
                    { name: 'state', type: 'string' },
                    { name: 'stateChangedAt', type: 'date-time' },
                    { name: 'tags', type: 'string' },
                    { name: 'to', type: 'string' },
                    { name: 'uid', type: 'string' },
                    { name: 'updatedAt', type: 'date-time' },
                    { name: 'userCallType', type: 'string' },
                    { name: 'vendorCallId', type: 'string' },
                    { name: 'voicemailRecordingUrl', type: 'string' },
                ],
            },
            servicenow: {
                contact: [
                    { name: 'country', type: 'string' },
                    { name: 'calendar_integration', type: 'string' },
                    { name: 'last_login_time', type: 'string' },
                    { name: 'last_login_device', type: 'string' },
                    { name: 'source', type: 'string' },
                    { name: 'sys_updated_on', type: 'string' },
                    { name: 'building', type: 'string' },
                    { name: 'web_service_access_only', type: 'string' },
                    { name: 'notification', type: 'string' },
                    { name: 'x_653404_test_email', type: 'string' },
                    { name: 'sys_updated_by', type: 'string' },
                    { name: 'enable_multifactor_authn', type: 'string' },
                    { name: 'sys_created_on', type: 'string' },
                    { name: 'sys_domain', type: 'string' },
                    { name: 'state', type: 'string' },
                    { name: 'vip', type: 'string' },
                    { name: 'sys_created_by', type: 'string' },
                    { name: 'zip', type: 'string' },
                    { name: 'home_phone', type: 'string' },
                    { name: 'time_format', type: 'string' },
                    { name: 'last_login', type: 'string' },
                    { name: 'default_perspective', type: 'string' },
                    { name: 'active', type: 'string' },
                    { name: 'average_daily_fte', type: 'string' },
                    { name: 'time_sheet_policy', type: 'string' },
                    { name: 'sys_domain_path', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'cost_center', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'employee_number', type: 'string' },
                    { name: 'gender', type: 'string' },
                    { name: 'city', type: 'string' },
                    { name: 'user_name', type: 'string' },
                    { name: 'failed_attempts', type: 'string' },
                    { name: 'edu_status', type: 'string' },
                    { name: 'roles', type: 'string' },
                    { name: 'title', type: 'string' },
                    { name: 'sys_class_name', type: 'string' },
                    { name: 'sys_id', type: 'string' },
                    { name: 'internal_integration_user', type: 'string' },
                    { name: 'ldap_server', type: 'string' },
                    { name: 'mobile_phone', type: 'string' },
                    { name: 'street', type: 'string' },
                    { name: 'company', type: 'string' },
                    { name: 'department', type: 'string' },
                    { name: 'first_name', type: 'string' },
                    { name: 'preferred_language', type: 'string' },
                    { name: 'introduction', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'manager', type: 'string' },
                    { name: 'locked_out', type: 'string' },
                    { name: 'sys_mod_count', type: 'string' },
                    { name: 'last_name', type: 'string' },
                    { name: 'photo', type: 'string' },
                    { name: 'avatar', type: 'string' },
                    { name: 'sys_tags', type: 'string' },
                    { name: 'middle_name', type: 'string' },
                    { name: 'time_zone', type: 'string' },
                    { name: 'schedule', type: 'string' },
                    { name: 'date_format', type: 'string' },
                    { name: 'location', type: 'string' },
                    { name: 'account', type: 'string' },
                ],
                case: [
                    { name: 'parent', type: 'string' },
                    { name: 'caused_by', type: 'string' },
                    { name: 'watch_list', type: 'string' },
                    { name: 'active_escalation', type: 'string' },
                    { name: 'upon_reject', type: 'string' },
                    { name: 'sys_updated_on', type: 'string' },
                    { name: 'support_manager', type: 'string' },
                    { name: 'approval_history', type: 'string' },
                    { name: 'skills', type: 'string' },
                    { name: 'number', type: 'string' },
                    { name: 'problem', type: 'string' },
                    { name: 'state', type: 'string' },
                    { name: 'case', type: 'string' },
                    { name: 'sys_created_by', type: 'string' },
                    { name: 'knowledge', type: 'string' },
                    { name: 'order', type: 'string' },
                    { name: 'assigned_on', type: 'string' },
                    { name: 'delivery_plan', type: 'string' },
                    { name: 'cmdb_ci', type: 'string' },
                    { name: 'impact', type: 'string' },
                    { name: 'contract', type: 'string' },
                    { name: 'active', type: 'string' },
                    { name: 'work_notes_list', type: 'string' },
                    { name: 'priority', type: 'string' },
                    { name: 'sys_domain_path', type: 'string' },
                    { name: 'rejection_goto', type: 'string' },
                    { name: 'first_response_time', type: 'string' },
                    { name: 'group_list', type: 'string' },
                    { name: 'business_duration', type: 'string' },
                    { name: 'sync_driver', type: 'string' },
                    { name: 'approval_set', type: 'string' },
                    { name: 'wf_activity', type: 'string' },
                    { name: 'universal_request', type: 'string' },
                    { name: 'short_description', type: 'string' },
                    { name: 'correlation_display', type: 'string' },
                    { name: 'delivery_task', type: 'string' },
                    { name: 'work_start', type: 'string' },
                    { name: 'additional_assignee_list', type: 'string' },
                    { name: 'notify', type: 'string' },
                    { name: 'service_offering', type: 'string' },
                    { name: 'sys_class_name', type: 'string' },
                    { name: 'follow_up', type: 'string' },
                    { name: 'closed_by', type: 'string' },
                    { name: 'contact_local_time', type: 'string' },
                    { name: 'sn_app_cs_social_social_profile', type: 'string' },
                    { name: 'reassignment_count', type: 'string' },
                    { name: 'contributor_users', type: 'string' },
                    { name: 'contact_time_zone', type: 'string' },
                    { name: 'notes_to_comments', type: 'string' },
                    { name: 'assigned_to', type: 'string' },
                    { name: 'product', type: 'string' },
                    { name: 'variables', type: 'string' },
                    { name: 'variable_pool', type: 'string' },
                    { name: 'hierarchical_variables', type: 'string' },
                    { name: 'sla_due', type: 'string' },
                    { name: 'change', type: 'string' },
                    { name: 'comments_and_work_notes', type: 'string' },
                    { name: 'partner', type: 'string' },
                    { name: 'escalation', type: 'string' },
                    { name: 'upon_approval', type: 'string' },
                    { name: 'partner_contact', type: 'string' },
                    { name: 'correlation_id', type: 'string' },
                    { name: 'asset', type: 'string' },
                    { name: 'made_sla', type: 'string' },
                    { name: 'task_effective_number', type: 'string' },
                    { name: 'resolved_by', type: 'string' },
                    { name: 'sys_updated_by', type: 'string' },
                    { name: 'user_input', type: 'string' },
                    { name: 'opened_by', type: 'string' },
                    { name: 'sys_created_on', type: 'string' },
                    { name: 'contact', type: 'string' },
                    { name: 'sys_domain', type: 'string' },
                    { name: 'route_reason', type: 'string' },
                    { name: 'contributor_groups', type: 'string' },
                    { name: 'closed_at', type: 'string' },
                    { name: 'follow_the_sun', type: 'string' },
                    { name: 'entitlement', type: 'string' },
                    { name: 'business_service', type: 'string' },
                    { name: 'time_worked', type: 'string' },
                    { name: 'expected_start', type: 'string' },
                    { name: 'opened_at', type: 'string' },
                    { name: 'work_end', type: 'string' },
                    { name: 'resolved_at', type: 'string' },
                    { name: 'case_report', type: 'string' },
                    { name: 'subcategory', type: 'string' },
                    { name: 'work_notes', type: 'string' },
                    { name: 'assignment_group', type: 'string' },
                    { name: 'cause', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'proactive', type: 'string' },
                    { name: 'calendar_duration', type: 'string' },
                    { name: 'close_notes', type: 'string' },
                    { name: 'auto_close', type: 'string' },
                    { name: 'sys_id', type: 'string' },
                    { name: 'contact_type', type: 'string' },
                    { name: 'resolution_code', type: 'string' },
                    { name: 'urgency', type: 'string' },
                    { name: 'company', type: 'string' },
                    { name: 'consumer', type: 'string' },
                    { name: 'activity_due', type: 'string' },
                    { name: 'comments', type: 'string' },
                    { name: 'approval', type: 'string' },
                    { name: 'due_date', type: 'string' },
                    { name: 'sys_mod_count', type: 'string' },
                    { name: 'internal_user', type: 'string' },
                    { name: 'sys_tags', type: 'string' },
                    { name: 'active_account_escalation', type: 'string' },
                    { name: 'location', type: 'string' },
                    { name: 'category', type: 'string' },
                    { name: 'account', type: 'string' },
                ],
                incident: [
                    { name: 'parent', type: 'string' },
                    { name: 'made_sla', type: 'string' },
                    { name: 'caused_by', type: 'string' },
                    { name: 'watch_list', type: 'string' },
                    { name: 'upon_reject', type: 'string' },
                    { name: 'sys_updated_on', type: 'string' },
                    { name: 'child_incidents', type: 'string' },
                    { name: 'hold_reason', type: 'string' },
                    { name: 'task_effective_number', type: 'string' },
                    { name: 'approval_history', type: 'string' },
                    { name: 'skills', type: 'string' },
                    { name: 'number', type: 'string' },
                    { name: 'resolved_by', type: 'string' },
                    { name: 'sys_updated_by', type: 'string' },
                    { name: 'opened_by', type: 'string' },
                    { name: 'user_input', type: 'string' },
                    { name: 'sys_created_on', type: 'string' },
                    { name: 'sys_domain', type: 'string' },
                    { name: 'state', type: 'string' },
                    { name: 'route_reason', type: 'string' },
                    { name: 'sys_created_by', type: 'string' },
                    { name: 'knowledge', type: 'string' },
                    { name: 'order', type: 'string' },
                    { name: 'calendar_stc', type: 'string' },
                    { name: 'closed_at', type: 'string' },
                    { name: 'cmdb_ci', type: 'string' },
                    { name: 'delivery_plan', type: 'string' },
                    { name: 'contract', type: 'string' },
                    { name: 'impact', type: 'string' },
                    { name: 'active', type: 'string' },
                    { name: 'work_notes_list', type: 'string' },
                    { name: 'business_service', type: 'string' },
                    { name: 'priority', type: 'string' },
                    { name: 'sys_domain_path', type: 'string' },
                    { name: 'rfc', type: 'string' },
                    { name: 'time_worked', type: 'string' },
                    { name: 'expected_start', type: 'string' },
                    { name: 'opened_at', type: 'string' },
                    { name: 'business_duration', type: 'string' },
                    { name: 'group_list', type: 'string' },
                    { name: 'work_end', type: 'string' },
                    { name: 'caller_id', type: 'string' },
                    { name: 'reopened_time', type: 'string' },
                    { name: 'resolved_at', type: 'string' },
                    { name: 'approval_set', type: 'string' },
                    { name: 'subcategory', type: 'string' },
                    { name: 'work_notes', type: 'string' },
                    { name: 'universal_request', type: 'string' },
                    { name: 'short_description', type: 'string' },
                    { name: 'close_code', type: 'string' },
                    { name: 'correlation_display', type: 'string' },
                    { name: 'delivery_task', type: 'string' },
                    { name: 'work_start', type: 'string' },
                    { name: 'assignment_group', type: 'string' },
                    { name: 'additional_assignee_list', type: 'string' },
                    { name: 'business_stc', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'calendar_duration', type: 'string' },
                    { name: 'close_notes', type: 'string' },
                    { name: 'notify', type: 'string' },
                    { name: 'service_offering', type: 'string' },
                    { name: 'sys_class_name', type: 'string' },
                    { name: 'closed_by', type: 'string' },
                    { name: 'follow_up', type: 'string' },
                    { name: 'parent_incident', type: 'string' },
                    { name: 'sys_id', type: 'string' },
                    { name: 'contact_type', type: 'string' },
                    { name: 'reopened_by', type: 'string' },
                    { name: 'incident_state', type: 'string' },
                    { name: 'urgency', type: 'string' },
                    { name: 'problem_id', type: 'string' },
                    { name: 'company', type: 'string' },
                    { name: 'reassignment_count', type: 'string' },
                    { name: 'activity_due', type: 'string' },
                    { name: 'assigned_to', type: 'string' },
                    { name: 'severity', type: 'string' },
                    { name: 'comments', type: 'string' },
                    { name: 'approval', type: 'string' },
                    { name: 'sla_due', type: 'string' },
                    { name: 'comments_and_work_notes', type: 'string' },
                    { name: 'due_date', type: 'string' },
                    { name: 'sys_mod_count', type: 'string' },
                    { name: 'reopen_count', type: 'string' },
                    { name: 'sys_tags', type: 'string' },
                    { name: 'escalation', type: 'string' },
                    { name: 'upon_approval', type: 'string' },
                    { name: 'correlation_id', type: 'string' },
                    { name: 'location', type: 'string' },
                    { name: 'category', type: 'string' },
                ],
                task: [
                    { name: 'parent', type: 'string' },
                    { name: 'made_sla', type: 'string' },
                    { name: 'watch_list', type: 'string' },
                    { name: 'sc_catalog', type: 'string' },
                    { name: 'upon_reject', type: 'string' },
                    { name: 'sys_updated_on', type: 'string' },
                    { name: 'task_effective_number', type: 'string' },
                    { name: 'approval_history', type: 'string' },
                    { name: 'skills', type: 'string' },
                    { name: 'number', type: 'string' },
                    { name: 'sys_updated_by', type: 'string' },
                    { name: 'opened_by', type: 'string' },
                    { name: 'user_input', type: 'string' },
                    { name: 'sys_created_on', type: 'string' },
                    { name: 'sys_domain', type: 'string' },
                    { name: 'state', type: 'string' },
                    { name: 'route_reason', type: 'string' },
                    { name: 'sys_created_by', type: 'string' },
                    { name: 'knowledge', type: 'string' },
                    { name: 'order', type: 'string' },
                    { name: 'calendar_stc', type: 'string' },
                    { name: 'closed_at', type: 'string' },
                    { name: 'cmdb_ci', type: 'string' },
                    { name: 'delivery_plan', type: 'string' },
                    { name: 'contract', type: 'string' },
                    { name: 'impact', type: 'string' },
                    { name: 'active', type: 'string' },
                    { name: 'work_notes_list', type: 'string' },
                    { name: 'business_service', type: 'string' },
                    { name: 'priority', type: 'string' },
                    { name: 'sys_domain_path', type: 'string' },
                    { name: 'time_worked', type: 'string' },
                    { name: 'expected_start', type: 'string' },
                    { name: 'opened_at', type: 'string' },
                    { name: 'business_duration', type: 'string' },
                    { name: 'group_list', type: 'string' },
                    { name: 'work_end', type: 'string' },
                    { name: 'approval_set', type: 'string' },
                    { name: 'work_notes', type: 'string' },
                    { name: 'universal_request', type: 'string' },
                    { name: 'request', type: 'string' },
                    { name: 'short_description', type: 'string' },
                    { name: 'correlation_display', type: 'string' },
                    { name: 'delivery_task', type: 'string' },
                    { name: 'work_start', type: 'string' },
                    { name: 'assignment_group', type: 'string' },
                    { name: 'additional_assignee_list', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'calendar_duration', type: 'string' },
                    { name: 'close_notes', type: 'string' },
                    { name: 'service_offering', type: 'string' },
                    { name: 'sys_class_name', type: 'string' },
                    { name: 'closed_by', type: 'string' },
                    { name: 'follow_up', type: 'string' },
                    { name: 'sys_id', type: 'string' },
                    { name: 'contact_type', type: 'string' },
                    { name: 'urgency', type: 'string' },
                    { name: 'company', type: 'string' },
                    { name: 'reassignment_count', type: 'string' },
                    { name: 'activity_due', type: 'string' },
                    { name: 'assigned_to', type: 'string' },
                    { name: 'comments', type: 'string' },
                    { name: 'approval', type: 'string' },
                    { name: 'sla_due', type: 'string' },
                    { name: 'comments_and_work_notes', type: 'string' },
                    { name: 'due_date', type: 'string' },
                    { name: 'sys_mod_count', type: 'string' },
                    { name: 'request_item', type: 'string' },
                    { name: 'sys_tags', type: 'string' },
                    { name: 'escalation', type: 'string' },
                    { name: 'upon_approval', type: 'string' },
                    { name: 'correlation_id', type: 'string' },
                    { name: 'location', type: 'string' },
                ],
            },
            gainsight: {
                accounts: [
                    { name: 'id', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'lastSeenDate', type: 'string' },
                    { name: 'last_login_device', type: 'string' },
                    { name: 'dunsNumber', type: 'string' },
                    { name: 'industry', type: 'string' },
                    { name: 'building', type: 'string' },
                    { name: 'numberOfEmployees', type: 'string' },
                    { name: 'propertyKeys', type: 'string' },
                    { name: 'sicCode', type: 'string' },
                    { name: 'website', type: 'string' },
                    { name: 'naicsCode', type: 'string' },
                    { name: 'plan', type: 'string' },
                    { name: 'countryName', type: 'string' },
                    { name: 'countryCode', type: 'string' },
                    { name: 'stateName', type: 'string' },
                    { name: 'stateCode', type: 'string' },
                    { name: 'cityName', type: 'string' },
                    { name: 'street', type: 'string' },
                    { name: 'postalCode', type: 'string' },
                    { name: 'continentCode', type: 'string' },
                    { name: 'regionName', type: 'string' },
                    { name: 'timeZone', type: 'string' }
                ],
                users: [
                    { name: 'aptrinsicId', type: 'string' },
                    { name: 'identifyId', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'gender', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'firstName', type: 'string' },
                    { name: 'lastName', type: 'string' },
                    { name: 'lastSeenDate', type: 'string' },
                    { name: 'signUpDate', type: 'string' },
                    { name: 'firstVisitDate', type: 'string' },
                    { name: 'title', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'score', type: 'string' },
                    { name: 'role', type: 'string' },
                    { name: 'subscriptionId', type: 'string' },
                    { name: 'numberOfVisits', type: 'string' },
                    { name: 'propertyKeys', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'accountId', type: 'string' },
                    { name: 'countryName', type: 'string' },
                    { name: 'countryCode', type: 'string' },
                    { name: 'stateName', type: 'string' },
                    { name: 'stateCode', type: 'string' },
                    { name: 'cityName', type: 'string' },
                    { name: 'street', type: 'string' },
                    { name: 'postalCode', type: 'string' },
                    { name: 'continentCode', type: 'string' },
                    { name: 'regionName', type: 'string' },
                    { name: 'timeZone', type: 'string' }
                ]
            },
            customerio: {
                customers: [
                    { name: 'id', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'anonymous_id', type: 'string' },
                    { name: 'created_at', type: 'integer' },
                    { name: '_update', type: 'boolean' },
                    { name: 'first_name', type: 'string' },
                    { name: 'plan', type: 'string' },
                    { name: 'cio_id', type: 'string' },
                    { name: 'platform', type: 'string' },
                    { name: 'last_used', type: 'integer' },
                    { name: 'unsubscribed', type: 'boolean' },
                    { name: 'devices', type: 'string' },
                ],
                events: [
                    { name: 'id', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'timestamp', type: 'integer' },
                    { name: 'first_name', type: 'string' },
                    { name: 'last_name', type: 'string' },
                    { name: 'anonymous_id', type: 'string' },
                    { name: 'delivery_id', type: 'string' },
                    { name: 'event', type: 'string' },
                    { name: 'device_id', type: 'string' },
                    { name: 'recipient', type: 'string' },
                    { name: 'from_address', type: 'string' },
                    { name: 'reply_to', type: 'string' },
                ],
                forms: [
                    { name: 'form_id', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'reply_to', type: 'string' },
                    { name: 'custom_field_1', type: 'string' },
                    { name: 'custom_field_2', type: 'string' },
                    { name: 'custom_field_3', type: 'string' },
                    { name: 'custom_field_4', type: 'string' },
                    { name: 'custom_field_5', type: 'string' },
                    { name: 'custom_field_6', type: 'string' },
                    { name: 'custom_field_7', type: 'string' },
                    { name: 'custom_field_8', type: 'string' },
                    { name: 'custom_field_9', type: 'string' },
                    { name: 'custom_field_10', type: 'string' },
                ],
                segments: [
                    { name: 'name', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'segment_id', type: 'integer' },
                    { name: 'start', type: 'string' },
                    { name: 'limit', type: 'integer' },
                    { name: 'id_type', type: 'string' },
                    { name: 'ids', type: 'string' },
                    { name: 'customer_id1', type: 'string' },
                    { name: 'customer_id2', type: 'string' },
                    { name: 'customer_id3', type: 'string' },
                    { name: 'customer_id4', type: 'string' },
                    { name: 'customer_id5', type: 'string' },
                    { name: 'customer_id6', type: 'string' },
                    { name: 'customer_id7', type: 'string' },
                    { name: 'customer_id8', type: 'string' },
                    { name: 'customer_id9', type: 'string' },
                    { name: 'customer_id10', type: 'string' },
                ],
                snippets: [
                    { name: 'name', type: 'string' },
                    { name: 'value', type: 'string' },
                    { name: 'updated_at', type: 'integer' },
                    { name: 'snippet_name', type: 'integer' },

                ],
                campaigns: [
                    { name: 'campaign_id', type: 'integer' },
                    { name: 'action_id', type: 'integer' },
                    { name: 'parent_action_id', type: 'integer' },
                    { name: 'created', type: 'integer' },
                    { name: 'updated', type: 'integer' },
                    { name: 'body', type: 'string' },
                    { name: 'sending_state', type: 'string' },
                    { name: 'from_id', type: 'integer' },
                    { name: 'reply_to_id', type: 'integer' },
                    { name: 'recipient', type: 'string' },
                    { name: 'subject', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'layout', type: 'string' },
                    { name: 'from', type: 'string' },
                    { name: 'reply_to', type: 'string' },
                    { name: 'preprocessor', type: 'string' },
                    { name: 'bbc', type: 'string' },
                    { name: 'fake_bcc', type: 'boolean' },
                    { name: 'preheader_text', type: 'string' },


                ],
            },
            activecampaign: {
                accounts: [
                    { name: 'id', type: 'integer' },
                    { name: 'name', type: 'string' },
                    { name: 'accountUrl', type: 'string' },
                    { name: 'owner', type: 'integer' },
                    { name: 'customFieldId', type: 'integer' },
                    { name: 'fieldValue', type: 'string' },
                    { name: 'fieldCurrency', type: 'string' },
                    { name: 'contactCount', type: 'integer' },
                    { name: 'dealCount', type: 'integer' },
                ],
                contacts: [
                    { name: 'id', type: 'integer' },
                    { name: 'email', type: 'string' },
                    { name: 'firstName', type: 'string' },
                    { name: 'lastName', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'fieldValues', type: 'array' },
                    { name: 'orgid', type: 'integer' },
                    { name: 'deleted', type: 'boolean' },
                ],
                lists: [
                    { name: 'id', type: 'integer' },
                    { name: 'name', type: 'string' },
                    { name: 'stringid', type: 'string' },
                    { name: 'sender_url', type: 'string' },
                    { name: 'sender_reminder', type: 'string' },
                    { name: 'send_last_broadcast', type: 'boolean' },
                    { name: 'carboncopy', type: 'string' },
                    { name: 'subscription_notify', type: 'string' },
                    { name: 'unsubscription_notify', type: 'string' },
                    { name: 'user', type: 'integer' },

                ],
                addresses: [
                    { name: 'id', type: 'integer' },
                    { name: 'groupid', type: 'integer' },
                    { name: 'global', type: 'string' },
                    { name: 'companyName', type: 'string' },
                    { name: 'address1', type: 'string' },
                    { name: 'address2', type: 'string' },
                    { name: 'city', type: 'string' },
                    { name: 'state', type: 'string' },
                    { name: 'zip', type: 'string' },
                    { name: 'district', type: 'string' },
                    { name: 'country', type: 'string' },
                    { name: 'is_default', type: 'boolean' },
                    { name: 'allgroup', type: 'integer' },
                ],
                users: [
                    { name: 'id', type: 'integer' },
                    { name: 'username', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'firstName', type: 'string' },
                    { name: 'lastName', type: 'string' },
                    { name: 'group', type: 'integer' },
                    { name: 'password', type: 'string' },

                ],
                deals: [
                    { name: 'id', type: 'integer' },
                    { name: 'contact', type: 'string' },
                    { name: 'account', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'currency', type: 'string' },
                    { name: 'group', type: 'string' },
                    { name: 'owner', type: 'string' },
                    { name: 'percent', type: 'integer' },
                    { name: 'stage', type: 'string' },
                    { name: 'status', type: 'integer' },
                    { name: 'title', type: 'string' },
                    { name: 'value', type: 'integer' },
                    { name: 'fields', type: 'array of objects' },
                ],
                groups: [
                    { name: 'id', type: 'integer' },
                    { name: 'title', type: 'string' },
                    { name: 'descript', type: 'string' },
                    { name: 'pgMessageAdd', type: 'boolean' },
                    { name: 'unsubscribelink', type: 'boolean' },
                    { name: 'optinconfirm', type: 'boolean' },
                    { name: 'pgListAdd', type: 'boolean' },
                    { name: 'pgListEdit', type: 'boolean' },
                    { name: 'pgListDelete', type: 'boolean' },
                    { name: 'pgListHeaders', type: 'boolean' },
                    { name: 'pgListEmailaccount', type: 'boolean' },
                    { name: 'pgListBounce', type: 'boolean' },
                    { name: 'pgMessageEdit', type: 'boolean' },
                    { name: 'pgMessageDelete', type: 'boolean' },
                    { name: 'pgMessageSend', type: 'boolean' },
                    { name: 'pgContactAdd', type: 'boolean' },
                    { name: 'pgContactEdit', type: 'boolean' },
                    { name: 'pgContactDelete', type: 'boolean' },
                    { name: 'pgContactMerge', type: 'boolean' },
                    { name: 'pgContactImport', type: 'boolean' },
                    { name: 'pgContactApprove', type: 'boolean' },
                    { name: 'pgContactExport', type: 'boolean' },
                    { name: 'pgContactSync', type: 'boolean' },
                    { name: 'pgContactFilters', type: 'boolean' },
                    { name: 'pgContactActions', type: 'boolean' },
                    { name: 'pgContactFields', type: 'boolean' },
                    { name: 'pg_user_add', type: 'boolean' },
                    { name: 'pg_user_edit', type: 'boolean' },
                    { name: 'pg_user_delete', type: 'boolean' },
                    { name: 'pgGroupAdd', type: 'boolean' },
                    { name: 'pgGroupEdit', type: 'boolean' },
                    { name: 'pgGroupDelete', type: 'boolean' },
                    { name: 'pgTemplateAdd', type: 'boolean' },
                    { name: 'pgTemplateEdit', type: 'boolean' },
                    { name: 'pgTemplateDelete', type: 'boolean' },
                    { name: 'pgPersonalizationAdd', type: 'boolean' },
                    { name: 'pgPersonalizationEdit', type: 'boolean' },
                    { name: 'pgPersonalizationDelete', type: 'boolean' },
                    { name: 'pgAutomationManage', type: 'boolean' },
                    { name: 'pgFormEdit', type: 'boolean' },
                    { name: 'pgReportsCampaign', type: 'boolean' },
                    { name: 'pgReportsList', type: 'boolean' },
                    { name: 'pgReportsUser', type: 'boolean' },
                    { name: 'pgStartupReports', type: 'boolean' },
                    { name: 'pgReportsTrend', type: 'boolean' },
                    { name: 'pgStartupGettingstarted', type: 'boolean' },
                    { name: 'pgDeal', type: 'boolean' },
                    { name: 'pgDealDelete', type: 'boolean' },
                    { name: 'pgDealReassign', type: 'boolean' },
                    { name: 'pgDealGroupAdd', type: 'boolean' },
                    { name: 'pgDealGroupEdit', type: 'boolean' },
                    { name: 'pgDealGroupDelete', type: 'boolean' },
                    { name: 'pgSavedResponsesManage', type: 'boolean' },
                    { name: 'pgTagManage', type: 'boolean' },
                    { name: 'reqApproval', type: 'boolean' },
                    { name: 'reqApproval1st', type: 'boolean' },
                    { name: 'reqApprovalNotify', type: 'string' },
                    { name: 'socialdata', type: 'boolean' },
                ],
            },
            pipedrive: {
                activities: [
                    { name: 'obj_id', type: 'integer' },
                    { name: 'due_date', type: 'string' },
                    { name: 'due_time', type: 'string' },
                    { name: 'duration', type: 'string' },
                    { name: 'deal_id', type: 'integer' },
                    { name: 'person_id', type: 'integer' },
                    { name: 'org_id', type: 'integer' },
                    { name: 'note', type: 'string' },
                    { name: 'location', type: 'string' },
                    { name: 'public_description', type: 'string' },
                    { name: 'subject', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'user_id', type: 'integer' },
                    { name: 'busy_flag', type: 'boolean' }
                ],
                organizations: [
                    { name: 'obj_id', type: 'integer' },
                    { name: 'name', type: 'string', isCompulsory: true },
                    { name: 'owner_id', type: 'integer' },
                    { name: 'visible_to', type: 'integer' }

                ],
                deals: [
                    { name: 'obj_id', type: 'integer' },
                    { name: 'title', type: 'string', isCompulsory: true },
                    { name: 'value', type: 'string' },
                    { name: 'currency', type: 'string' },
                    { name: 'user_id', type: 'integer' },
                    { name: 'person_id', type: 'integer' },
                    { name: 'org_id', type: 'integer' },
                    { name: 'stage_id', type: 'integer' },
                    { name: 'status', type: 'string' },
                    { name: 'expected_close_date', type: 'string(YYYY-MM-DD)' },
                    { name: 'probability', type: 'number' },
                    { name: 'lost_reason', type: 'string' },
                    { name: 'add_time', type: 'string(YYYY-MM-DD)' }
                ],

                leads: [
                    { name: 'obj_id', type: 'string' },
                    { name: 'title', type: 'string', isCompulsory: true },
                    { name: 'owner_id', type: 'integer' },
                    { name: 'person_id', type: 'integer' },
                    { name: 'organization_id', type: 'integer' },
                    { name: 'was_seen', type: 'boolean' },
                    { name: 'expected_close_date', type: 'string(YYYY-MM-DD)' }
                ]
            },

            front: {
                accounts: [
                    { name: 'account_id', type: 'string' },
                    { name: 'name', type: 'string', isCompulsory: true },
                    { name: 'description', type: 'string' },
                    { name: 'domains', type: 'string' },
                    { name: 'external_id', type: 'string' },

                ],
                channels: [
                    { name: 'channel_id', type: 'string' },
                    { name: 'inbox_id', type: 'string', isCompulsory: true },
                    { name: 'name', type: 'string' },
                    { name: 'undo_send_time', type: 'integer' },
                    { name: 'all_teammates_can_reply', type: 'boolean' },
                    { name: 'type', type: 'string', isCompulsory: true },
                    { name: 'send_as', type: 'string' },

                ],
                contacts: [
                    { name: 'contact_id', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'description', type: 'string' },
                    { name: 'is_spammer', type: 'boolean' },
                    { name: 'handle', type: 'string', isCompulsory: true }, //not required for update
                    { name: 'source', type: 'string', isCompulsory: true }, //try updating contact with handle and source //not required for update 
                ],
                contact_handles: [
                    { name: 'contact_id', type: 'string', isCompulsory: true },
                    { name: 'handle', type: 'string', isCompulsory: true },
                    { name: 'source', type: 'string', isCompulsory: true }
                ]
            },
            close: {
                lead: [],
                contact: [],
                opportunity: [],
                task: [
                    { name: 'task_id', type: 'string', isCompulsory: true },
                    { name: 'lead_id', type: 'string', isCompulsory: true },
                    { name: 'assigned_to', type: 'string', isCompulsory: true },
                    { name: 'date', type: 'string(YYYY-MM-DD)' },
                    { name: 'text', type: 'string' },
                    { name: 'is_complete', type: 'boolean' },
                    { name: 'view', type: 'string' },
                    { name: 'contact_id', type: 'string' },
                    { name: 'is_dateless', type: 'boolean' },
                    { name: '_type', type: 'string' },
                ],
                group: [
                    { name: 'name', type: 'string', isCompulsory: true },
                    { name: 'group_id', type: 'string' },
                    { name: 'user_id', type: 'string' }

                ]

            },

            mailchimp: {
                members: [
                    { name: 'contact_id', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'email_address', type: 'string' },
                    { name: 'status', type: 'string' },
                    //{name: 'merge_fields', type: 'string'},
                    { name: 'FNAME', type: 'string' },
                    { name: 'LNAME', type: 'string' },
                    { name: 'PHONE', type: 'string' },
                    //{name: 'ADDRESS', type: 'integer'},
                    { name: 'addr1', type: 'date-time' },
                    { name: 'addr2', type: 'string' },
                    { name: 'city', type: 'integer' },
                    { name: 'state', type: 'string' },
                    { name: 'zip', type: 'string' },
                    { name: 'country', type: 'boolean' },
                ],
            },
            linkedinads: {
                adAccountsV2: [
                    { name: 'id', type: 'string' },
                    { name: 'currency', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'notifiedOnCampaignOptimization', type: 'string' },
                    { name: 'notifiedOnCreativeApproval', type: 'string' },
                    { name: 'notifiedOnCreativeRejection', type: 'string' },
                    { name: 'notifiedOnEndOfCampaign', type: 'string' },
                    { name: 'reference', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'test', type: 'string' },
                ],
                adCampaignGroupsV2: [
                    { name: 'id', type: 'string' },
                    { name: 'account', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'end', type: 'string' },
                    { name: 'start', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'tot_budget_amount', type: 'string' },
                    { name: 'tot_budget_currencyCode', type: 'string' },
                ],
                adCampaignsV2: [
                    { name: 'id', type: 'string' },
                    { name: 'account', type: 'string' },
                    { name: 'campaignGroup', type: 'string' },
                    { name: 'audienceExpansionEnabled', type: 'string' },
                    { name: 'costType', type: 'string' },
                    { name: 'creativeSelection', type: 'string' },
                    { name: 'daily_budget_amount', type: 'string' },
                    { name: 'daily_budget_currencyCode', type: 'string' },
                    { name: 'locale_country', type: 'string' },
                    { name: 'locale_language', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'offsiteDeliveryEnabled', type: 'string' },
                    { name: 'end', type: 'string' },
                    { name: 'start', type: 'string' },
                    { name: 'type', type: 'string' },
                    { name: 'unitcost_amount', type: 'string' },
                    { name: 'unitcost_currencyCode', type: 'string' },
                    { name: 'status', type: 'string' },
                ],
            },
            drift: {
                contacts: [],
                accounts: [
                    { name: 'ownerId', type: 'integer' },
                    { name: 'domain', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'deleted', type: 'boolean' },
                    { name: 'targeted', type: 'boolean' },
                    { name: 'accountId', type: 'integer' },
                ],
                users: [
                    { name: 'id', type: 'integer' },
                    { name: 'alias', type: 'string' },
                    { name: 'name', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'locale', type: 'string' },
                    { name: 'avatarUrl', type: 'string' },
                    { name: 'availability', type: 'string (AVAILABLE/OFFLINE)' },
                ],
                conversations: [
                    { name: 'email', type: 'string' },
                    { name: 'message', type: 'string' },
                    { name: 'integrationSource', type: 'string' }
                ],
                messages: [
                    { name: 'type', type: 'string (chat/private_note)' },
                    { name: 'userId', type: 'integer' },
                    { name: 'body', type: 'string' },
                    { name: 'conversationId', type: 'integer' }
                ]

            },

            facebook: [
                {
                    key: 'EXTERN_ID',
                    label: 'external id',
                    guidelines: 'This can be any unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.'
                },
                {
                    key: 'EMAIL',
                    label: 'email address',
                    guidelines: 'Trim leading and trailing white space, and convert all characters to lowercase.'
                },
                {
                    key: 'PHONE',
                    label: 'phone number',
                    guidelines: 'Remove symbols, letters, and any leading zeroes. You should prefix the country code if the COUNTRY field is not specified.'
                },
                {
                    key: 'GEN',
                    label: 'gender',
                    guidelines: 'Use these values: m for male, f for female.'
                },
                {
                    key: 'DOBY',
                    label: 'birth year',
                    guidelines: 'Use the YYYY format: 1900 to the current year.'
                },
                {
                    key: 'DOBM',
                    label: 'birth month',
                    guidelines: 'Use the MM format: 01 to 12.'
                },
                {
                    key: 'DOBD',
                    label: 'birth day',
                    guidelines: 'Use the DD format: 01 to 31.'
                },
                {
                    key: 'FN',
                    label: 'first name',
                    guidelines: 'Use a-z only. Lowercase only, no punctuation. Special characters in UTF-8 format.'
                },
                {
                    key: 'LN',
                    label: 'last name',
                    guidelines: 'Use a-z only. Lowercase only, no punctuation. Special characters in UTF-8 format.'
                },
                {
                    key: 'FI',
                    label: 'first name initial',
                    guidelines: 'Use a-z only. Lowercase only. Special characters in UTF-8 format.'
                },
                {
                    key: 'ST',
                    label: 'US state',
                    guidelines: 'Use the 2-character ANSI abbreviation code, lowercase. Normalize states outside the US in lowercase, with no punctuation, no special characters, and no white space.'
                },
                {
                    key: 'CT',
                    label: 'city',
                    guidelines: 'Use a-z only. Lowercase only, with no punctuation, no special characters, and no white space.'
                },
                {
                    key: 'ZIP',
                    label: 'zip code',
                    guidelines: 'Use lowercase, and no white space. For the US, use only the first 5 digits. For the UK, use the Area/District/Sector format.'
                },
                {
                    key: 'COUNTRY',
                    label: 'country code',
                    guidelines: 'Use lowercase, 2-letter country codes in ISO 3166-1 alpha-2.'
                },
                {
                    key: 'MADID',
                    label: 'mobile advertiser ID',
                    guidelines: 'Hashing NOT required Use all lowercase, and keep hyphens.'
                },
            ],

        },
        dbMeta: false,
        gettingDbMeta: false,
        sfdcMetadata: {},
        gettingSfdc: false,
        gotAllSfdc: false,
        dbError: false,
        paramError: false,
        refreshDb: false,
        forceFullRefresh: false,
        dbs: {},
        setSourceId: false,
        sets: [],
        dataModel: {
            users: {
                rows: [],
            }
        },
        settings: {
            team: {
                queues: [
                    { id: 0, name: 'High', query: '#high' },
                    { id: 1, name: 'Medium', query: '#medium' },
                    { id: 2, name: 'Today', query: '!today' },
                ],
                members: [],
                soup: false,
            },
            user: {
                me: {
                    trial_expired: 0,
                }
            }
        },
        apiKey: false,
        cmdkActive: false,
        restrictedPaths: ['run', 'docs', 'blocks', ''],
        permissions: [
            {
                value: 'sql.view',
                path: '/run',
            },
            {
                value: 'sql.run',
                path: '/run',
            },
            {
                value: 'blocks.all',
                path: '/blocks',
            },
            {
                value: 'blocks.tagged',
                path: '/blocks',
            },
            {
                value: 'blocks.view',
                path: '/blocks',
            },
            {
                value: 'addon.run',
                path: '/addon',
            },
            {
                value: 'form.run',
                path: '/form',
            },
            {
                value: 'docs.view',
                path: '/docs',
            },
        ],
        updateUser: {
            email: false
        },
        justClosedCmdk: false,
        cmdkForm: false,
        cmdkInput: '',
        hideCmdkInputParents: [
            'sendInvite', 'sendInvite2', 'getApiKey', 'shareBlock2', 'pivotTable',
            'updateUserRolesPermissions2', 'trash', 'createTablesFromSheet',
            'autoImportToSheets', 'addIntegration'
        ],
        searchTerm: '',
        searchRes: [],
        searchSuggestions: [],
        showSuggestions: false,
        endOfLine: false,
        currentFocus: window.location.pathname.replace('/', ''),
        previousFocus: window.location.pathname.replace('/', ''),
        details: {},
        message: 'None yet!',
        snackbar: false,
        snacktime: 13000,
        searchIndex: 0,
        pendingIntegration: {},
        cmdkParentCmd: false,
        profile: {
            picture: 'https://lh3.googleusercontent.com/a-/AAuE7mCy47NGBRrWqiwcXQHFAXkCLhdAcF3Aag05H1AK'
        },
        editingComment: false,
        comments: [],
        reminderOptions: [
            { calc: function () { return moment() }, operator: '<=', text: 'pastdue' },
            { calc: function () { return moment().endOf('day') }, operator: '<=', text: 'today' },
            { calc: function () { return moment().add(1, 'day').endOf('day') }, operator: '<=', text: 'tomorrow' },
            { calc: function () { return moment().endOf('week') }, operator: '<=', text: 'thisweek' },
            { calc: function () { return moment().endOf('month') }, operator: '<=', text: 'thismonth' },
        ],
        suggestedReminder: false,
        addingTag: false,
        setTag: {
            "text": "Set",
            "value": "c6829bcc30324df584d5e95fe0b6e275"
        },
        snippetTag: {
            "text": "snippet",
            "value": "89bf150a809744cfbbc78b16f23175dc"
        },
        formTag: {
            "text": "form",
            "value": "form"
        },
        tagList: [],
        blockTags: [
            // {
            //   "text": "Set",
            //   "value": "c6829bcc30324df584d5e95fe0b6e275"
            // },
        ],
        // blockTags: [
        //   {value: 'owvj0wj089233', text: 'done'},
        //   {value: 'tgsf897shsrg', text: 'high'},
        //   {value: 'alskj98rwsdvasr', text: 'medium'},
        //   {value: 'afvoiwsds', text: 'giftcard'},
        //   {value: 'df90889wrekhjwrhj', text: 'new'},
        //   {value: 'sertg', text: 'employees', data: 100},
        // ],
        allTags: [
            { value: 'owvj0wj089233', text: 'done' },
            { value: 'tgsf897shsrg', text: 'high' },
            { value: 'alskj98rwsdvasr', text: 'medium' },
            { value: 'afvoiwsds', text: 'giftcard' },
            { value: 'df90889wrekhjwrhj', text: 'new' },
            { value: 'sertg', text: 'employees', data: 100 },
        ],
        compositionSuggestions: [],
        autocompletePreloaded: {
            postgres: [{
                dbNodeId: "ilike",
                name: "ILIKE",
                value: "ILIKE '%{{0}}%'",
                search: "ilike contains filter",
                type: "snippet"
            },
            {
                dbNodeId: "like",
                name: "LIKE",
                value: "LIKE '%{{0}}%'",
                search: "like contains filter",
                type: "snippet"
            },
            {
                dbNodeId: "dateFormatYear",
                name: "Year (format as YYYY)",
                value: "date_trunc('year', {{0}})",
                search: "format date year yyyy date_trunc",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateFormatMonth",
                name: "Month (format as YYYY-MM)",
                value: "date_trunc('month', {{0}})::date",
                search: "format date month yyyy mm date_trunc",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateFormatWeek",
                name: "Week (format as YYYY-MM-DD)",
                value: "date_trunc('week', {{0}})::date",
                search: "format date week date_trunc",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateFormatDay",
                name: "Day / Date (format as YYYY-MM-DD)",
                value: "date_trunc('day', {{0}})::date",
                search: "format date day yyyy mm date_trunc",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateFormatHour",
                name: "Hour (format as YYYY-MM-DD HH)",
                value: "date_trunc('hour', {{0}})",
                search: "format date hour date_trunc",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateToday",
                name: "Today",
                value: "(CURRENT_DATE){{0}}",
                search: "format date get today",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateYesterday",
                name: "Yesterday",
                value: "(CURRENT_DATE - INTERVAL '1 days'){{0}}",
                search: "format date get yesterday",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateLastWeek",
                name: "Last week",
                value: "(CURRENT_DATE - INTERVAL '7 days'){{0}}",
                search: "format date get last week",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateThisMonth",
                name: "This month",
                value: "date_trunc('month', CURRENT_DATE){{0}}",
                search: "format date get this month",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateLastMonth",
                name: "Last month",
                value: "date_trunc('month', (CURRENT_DATE - INTERVAL '1 months')){{0}}",
                search: "format date get last month",
                type: "snippet",
                icon: "calendar"
            }
            ],
            mysql: [{
                dbNodeId: "like",
                name: "LIKE",
                value: "LIKE '%{{0}}%'",
                search: "like contains filter",
                type: "snippet"
            },
            {
                dbNodeId: "dateFormatDay",
                name: "Day (format date to yyyy-mm-dd)",
                value: "DATE_FORMAT({{0}}, '%Y-%m-%d')",
                type: "snippet",
                icon: "calendar"
            },
            {
                dbNodeId: "dateFormatHour",
                name: "Hour (format date to yyyy-mm-dd HH)",
                value: "DATE_FORMAT({{0}}, '%Y-%m-%d %H')",
                type: "snippet",
                icon: "calendar"
            },
            ]
        },
        suggestedTag: false,
        tagActive: false,
        defaultTime: {
            hour: 14,
            minute: 30,
            second: 0,
            zone: 'EST',
            utcOffset: 240, //offset in minutes
        },
        gotUsageReport: false,
        monthlyRuns: 0,
        user_domain: "",
        usageReport: [],
        plan_runs: 0,
        user_plan: ""

    },
    uuidv4() {
        return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    },
    getFromLocalStorage(key) {
        return JSON.parse(localStorage.getItem(key) || false);
    },
    saveToLocalStorage(key, item) {
        localStorage.setItem(key, JSON.stringify(item));
    },
    moment: function () {
        return moment();
    },
    addMissingBlockAttributes(block) {
        let template = JSON.parse(JSON.stringify(store.state.blockTemplate))
        return _.merge(template, block);
    },
    getSqlDateFormat(column, label, format, dbType) {
        var dateFormatDict = {
            'YYYY-MM-DD': '%Y-%m-%d',
            'YYYY-MM': '%Y-%m',
            'YYYY': '%Y'
        }
        var dateFormatLabels = {
            'YYYY-MM-DD': 'Date',
            'YYYY-MM-W': 'Week',
            'YYYY-MM': 'Month',
            'YYYY': 'Year',
            'raw': 'Raw'
        }
        var sqlNoLabel = ''
        var newSql = ''
        if (dbType == 'mysql') {
            if (format == 'YYYY-MM-W') {
                var sqlNoLabel = "DATE_FORMAT(DATE_ADD(" + column + ", INTERVAL(1-DAYOFWEEK(" + column + ")) DAY), '%Y-%m-%d')"
                newSql = sqlNoLabel + ' AS "' + label + ' ' + dateFormatLabels[format] + '"'
            } else {
                var mySqlFormat = dateFormatDict[format]
                var sqlNoLabel = "DATE_FORMAT(" + column + ", '" + mySqlFormat + "')"
                newSql = sqlNoLabel + ' AS "' + label + ' ' + dateFormatLabels[format] + '"'
            }
        } else if (format == 'raw') {
            var sqlNoLabel = column
            newSql = sqlNoLabel + ' AS "' + label + ' ' + dateFormatLabels[format] + '"'
        } else {
            if (format == 'YYYY-MM-W' && dbType == 'postgres') {
                var sqlNoLabel = "DATE_TRUNC('week', " + column + ")::date"
                newSql = sqlNoLabel + ' AS "' + label + ' ' + dateFormatLabels[format] + '"'
            } else {
                var sqlNoLabel = "TO_CHAR(" + column + ", '" + format + "')"
                newSql = sqlNoLabel + ' AS "' + label + ' ' + dateFormatLabels[format] + '"'
            }
        }
        return {
            sql: newSql,
            sqlNoLabel: sqlNoLabel
        }
    },
    pastDue(row) {
        let detail_type = 'users'
        let details = this.state.editableDetailsAll[`${detail_type}-${row.email}`]
        if (details && details.reminder) {
            let date = moment(details.reminder)
            let red = moment(date).isSameOrBefore(moment())
            if (date) return { red: red, color: red ? '#eb5757' : '#2eaadc' };
        }
        return { red: false, color: '#eee' }
    },
    autoAddSelected(autoSelected, searchTerm, wordRange, beforeSearch, line) {
        let doc = window.editor.getDoc();
        let code = window.editor.getValue()
        // if (!code.include(' ') && !code.include('.')) {
        if (code.trim() == searchTerm.trim() && autoSelected.type != 'snippet') { //empty cell, add more than just name
            if (autoSelected.type == 'table') {
                let al = this.generateAlias(autoSelected.sql.table.split('.')[autoSelected.sql.table.split('.').length - 1])
                let addThis = `select ${al}.*\nfrom ${autoSelected.sql.table} as ${al}\nwhere 1=1`
                doc.replaceRange(addThis, wordRange.anchor, wordRange.head);
            } else if (autoSelected.type == 'column') {
                let table = autoSelected.sql.table
                let al = this.generateAlias(table.split('.')[table.split('.').length - 1])
                let addThis = `select ${al}.${autoSelected.sql.column}\nfrom ${table} AS ${al}\nwhere 1=1`
                doc.replaceRange(addThis, wordRange.anchor, wordRange.head);
            } else {
                doc.replaceRange(autoSelected.sql.column, wordRange.anchor, wordRange.head);
            }
        } else if (autoSelected.type == 'join') {
            let addThis = `${autoSelected.sql.join}`
            if (line.toLowerCase().includes('join')) {
                addThis += ' on '
            }
            doc.replaceRange(addThis, wordRange.anchor, wordRange.head);
        } else if (autoSelected.type == 'table' && beforeSearch != '.' && searchTerm != '.') {
            let al = this.generateAlias(autoSelected.sql.table)
            let addThis = `${autoSelected.sql.table} as ${al}`
            if (line.toLowerCase().includes('join')) {
                addThis += ' on '
            }
            doc.replaceRange(addThis, wordRange.anchor, wordRange.head);
        } else if (autoSelected.type == 'snippet') {
            doc.replaceRange(autoSelected.code, wordRange.anchor, wordRange.head);
        } else if (["'", ".", " "].includes(searchTerm)) { //when search term is space, need to add a space
            doc.replaceRange(String(autoSelected.title), { line: wordRange.anchor.line, ch: wordRange.anchor.ch + 1 }, wordRange.head);
        } else if (searchTerm == '') { //when search term is space, need to add a space
            doc.replaceRange(String(autoSelected.title), window.editor.getCursor(), window.editor.getCursor());
        } else { //just add name
            doc.replaceRange(String(autoSelected.title), wordRange.anchor, wordRange.head);
        }
        store.state.showSuggestions = false
        store.state.searchIndex = -1
        return
    },
    sendInvites(opts) {
        let d = {
            sessionId: this.state.sessionId,
            invited: opts.invited || [],
        }
        this.state.sendingInvites = true
        let path = this.getPath('/soup_send_invites')
        var self = this
        axios.post(path, d)
            .then((res) => {
                console.log(`done ${path}`, res.data)
                if (res.data.ok) self.state.inviteId = res.data.inviteUUID
                self.state.sendingInvites = false
                window.bus.$emit('invitesSent', { done: true })
            })
            .catch((error) => {
                console.error(error);
            });
    },
    generateAlias(table) {
        var alias = ''
        if (table.includes('_')) {
            let arr = table.split('_')
            for (let i = 0; i < arr.length; i++) {
                alias += arr[i][0];
            }
        } else {
            alias = table[0]
        }
        return alias.toLowerCase()
    },
    getIcon(icon, cn) {
        let className = cn || 'w-6 h-6'
        let icons = {
            database: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4">
                </path>
                </svg>`,
            happy: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                </path>
                </svg>
            `,
            externalLink: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14">
                </path>
                </svg>
            `,
            code: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4">
                </path>
                </svg>
            `,
            clock: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z">
                </path>
                </svg>
            `,
            check: `
                <svg class="${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
            `,
            user: `
                <svg class="${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd">
                    </path>
                </svg>
            `,
            'x-circle': `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z">
                    </path>
                </svg>
            `,
            'arrow-right': `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3">
                    </path>
                </svg>
            `,
            'arrow-right-circle': `
                <svg class="${className}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            `,
            x: `
                <svg class="${className}" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                    </path>
                </svg>
            `
        }
        return icons[icon] || icons.happy
    },
    getPath(path) {
        if (window.location.hostname === 'localhost' && !this.state.forceProd) {
            return `https://seekwell-staging-332907.wn.r.appspot.com${path}`
        }
        return `https://seekwell.io${path}`
        //return `http://localhost:8081${path}`

    },
    getPathRunner(path) {
        if (window.location.hostname === 'localhost' && !this.state.forceProdRunner) {
            //return `http://localhost:8002${path}`
            return `http://localhost:8082${path}`
        }
        return `https://api.seekwell.io${path}`
        //return `http://localhost:8082${path}`

    },
    updateEditableDetails(detail_id, detail_type, details) {
        // store.updateWebSqlDetails(`${detail_type}-${detail_id}`, details)
        let d = {
            sessionId: this.state.sessionId,
            detail_id: detail_id,
            detail_type: detail_type,
            details: this.state.editableDetails
        }
        this.state.editableDetailsAll[`${detail_type}-${detail_id}`] = this.state.editableDetails
        let path = this.getPath('/soup_update_details')

        axios.post(path, d)
            .then((res) => {
                console.log(`updated ${path}`, res.data)
            })
            .catch((error) => {
                console.error(error);
            });
    },
    deleteBlock(block) {
        delete this.state.blocks[block.uuid]
        let path = this.getPath('/soup_update_block')
        block.deleted = true
        let d = {
            sessionId: this.state.sessionId,
            details: block
        }
        axios.post(path, d)
            .then((res) => {
                console.log(`updated ${path}`, res.data)
            })
            .catch((error) => {
                console.error(error);
            });
    },
    updateTagList() {
        this.state.blockTagCounts = {}
        for (let [key, value] of Object.entries(this.state.blocks)) {
            let blockTagKeys = value.tags.map(t => t.value)
            for (let itag = 0; itag < value.tags.length; itag++) {
                const tagKey = value.tags[itag];
                if (this.state.blockTagCounts[tagKey.text]) {
                    this.state.blockTagCounts[tagKey.text] += 1
                } else {
                    this.state.blockTagCounts[tagKey.text] = 1
                }
            }
        }
        this.state.tagList = []
        for (let [key, value] of Object.entries(this.state.blockTagCounts)) {
            this.state.tagList.push({ text: key, ct: value })
        }
        this.state.tagList.sort((a, b) => { return b.ct - a.ct; })
    },
    deleteSource(source) {
        let path = this.getPath('/soup_update_source')
        source.deleted = true
        let d = {
            sessionId: this.state.sessionId,
            details: source
        }
        axios.post(path, d)
            .then((res) => {
                console.log(`updated ${path}`, res.data)
            })
            .catch((error) => {
                console.error(error);
            });
    },
    lowercaseObjKeys(obj) {
        try {
            var key, keys = Object.keys(obj);
            var n = keys.length;
            var newobj = {}
            while (n--) {
                key = keys[n];
                newobj[key.toLowerCase()] = obj[key];
            }
            return newobj
        } catch (error) {
            return obj
            console.error('lowercaseObjKeys: ', error)
        }
    },
    favoriteSource(source) {
        let path = this.getPath('/soup_update_source')
        let d = {
            sessionId: this.state.sessionId,
            details: source
        }
        axios.post(path, d)
            .then((res) => {
                console.log(`updated ${path}`, res.data)
            })
            .catch((error) => {
                console.error(error);
            });
    },
    cleanUpBlock(block) {
        if (!block) return
        let clean = this.makeBlockSafe(block)
        clean.source.meta = 'cleaned'
        clean.results.rows = 'cleaned'
        return clean
    },
    makeBlockSafe(block) {
        let hasDataSets = _.get(block, 'viz.datacollection.datasets')
        if (hasDataSets) {
            for (let i = 0; i < block.viz.datacollection.datasets.length; i++) {
                block.viz.datacollection.datasets[i]._meta = {}
            }
        }
        return JSON.parse(JSON.stringify(block))
    },
    updateLocalStorageBlocks() {

    },
    updateBlock(opts) {
        if (opts.block) {
            var block = opts.block
        } else {
            var block = this.state.block
        }
        if (!block) return
        if (opts && 'gotBlock' in opts && !opts.gotBlock) return
        if (opts && opts.block) block = opts.block
        block.viewedOn = moment.unix(moment()).utc()._i
        this.state.blocks[block.uuid] = block
        block = this.makeBlockSafe(block)
        // block.results.rows = []
        if (opts.sliceAt) {
            block.results.rows = block.results.rows.slice(0, opts.sliceAt)
        } else {
            block.results.rows = block.results.rows.slice(0, 10)
        }
        block.source.meta = false
        let d = {
            sessionId: this.state.sessionId,
            details: block
        }
        let path = this.getPath('/soup_update_block')
        axios.post(path, d)
            .then((res) => {
                console.log(`updated ${path}`, res.data)
            })
            .catch((error) => {
                console.error(error);
            });
    },
    updateAst(opts) {
        let block = this.state.block
        let d2 = {
            sessionId: this.state.sessionId,
            uuid: block.uuid,
            code: block.code,
        }
        let path2 = this.getPath('/soup_get_ast')
        axios.post(path2, d2)
            .then((res) => {
                console.log(`ast `, res.data)
                if (res.data.ok) {
                    store.state.block.ast = res.data.data.ast
                }
            })
            .catch((error) => {
                console.error(error);
            });
    },
    compareValues(key, order = 'asc') {
        return function (a, b) {
            if (!a.hasOwnProperty(key) ||
                !b.hasOwnProperty(key)) {
                return 0;
            }

            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ?
                    (comparison * -1) : comparison
            );
        };
    },
    compareNums(key, order = 'asc') {
        return function (a, b) {
            if (!a.hasOwnProperty(key) ||
                !b.hasOwnProperty(key)) {
                return 0;
            }

            const varA = (typeof a[key] === 'string') ?
                a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ?
                b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order == 'desc') ?
                    (comparison * -1) : comparison
            );
        };
    },
    filterObject: function (item) {
        const allowed = this.state.dfObjects
        let filtered = Object.keys(item)
            .filter(key => allowed.includes(key))
            .reduce((obj, key) => {
                return {
                    ...obj,
                    [key]: item[key]
                };
            }, {});
        return filtered
    },
    sqlGetValStr(row, cols) {
        var vals = ''
        for (let i = 0; i < cols.length; i++) {
            let val = row[cols[i]]
            vals += `"${val}", `
        }
        return vals.slice(0, vals.length - 2)
    },
    getSheetUrl() {
        let ss_id = this.state.block.destination.ss_id
        let sheetName = this.state.block.destination.sheet
        let sheets = this.state.destinations.spreadSheetMetadata.sheets
        if (!sheets && ss_id) return `https://docs.google.com/spreadsheets/d/${ss_id}`
        if (!sheets) return 'https://docs.google.com/spreadsheets'
        let sheet = sheets.find(s => s.properties.title === sheetName)
        var sheetId = 0
        if (sheet && sheet.properties && sheet.properties.sheetId) sheetId = sheet.properties.sheetId
        return `https://docs.google.com/spreadsheets/d/${ss_id}/edit#gid=${sheetId}`
    },
    getSpreadsheetName(row) {
        let s = this.state.destinations.spreadSheets.find(s => s.id === row.destination.ss_id)
        if (s && s.name) return `${s.name} (${row.destination.sheet}!${row.destination.cell})`
        return ''
    },
    getHelp() {
        // Intercom('show')
        store.state.showHelp = true
    },
    getBlockSummary(row) {

        if (!this.state.sources) return ''
        if (!this.state.destinations.spreadSheets) return ''
        let destination = this.getDestinationSummary(row)
        let source = this.state.allSources.find(s => s.block_uuid === row.source.uuid)
        var sourceName = ''
        if (source && source.name) sourceName = source.name
        if (row.cellType === 'story') sourceName = 'Story'
        if (row.cellType === 'doc') sourceName = 'Dashboard'
        if (row.cellType === 'sheetsAsSql') sourceName = 'Sheets / CSV / Blocks'
        let s = this.state.destinations.spreadSheets.find(s => s.id === row.destination.ss_id)
        if (s && s.name) {
            return `${sourceName} → ${s.name} → ${row.destination.sheet}`
        } else if (row.destination.type === 'slack' && !this.state.destinations.slack) {
            return `${sourceName} → ${row.destination.channel}`
        } else if (row.destination.type === 'intercom') {
            return `${sourceName} → Intercom (${row.destination.intercom.role})`
        } else if (row.destination.type === 'email') {
            return `${sourceName} → ${row.destination.emails}`
        } else if (destination != 'Add destination') {
            return `${sourceName} → ${destination}`
        }
        else if (row.destination.type === 'msteams') {
            return `${sourceName} → ${row.destination.msteams}`

        }

        return sourceName
    },
    getDestinationSummary(row) {
        if (!row.destination.type) return 'None'
        // if (!row.destination.ss_id) return 'None'
        if (row.destination.type === 'sheets') {
            // if (!this.state.gotSheets) return `<a class="sw-blue" href="https://seekwell.io/web_auth_sheets" target="_blank">Click here to authorize access to Sheets</a>`
            if (!this.state.gotSheets) return `<a class="sw-blue">Sheets</a>`
            let s = this.state.destinations.spreadSheets.find(s => s.id === row.destination.ss_id)
            if (s && s.name) return `${s.name} → ${row.destination.sheet || ''}!${row.destination.cell || ''}`
        } else if (row.destination.type === 'excel' && row.excelLocation === 'googledrive') {
            if (!this.state.gotWorkbooks) return `<a class="sw-blue" href="https://seekwell.io/web_auth_sheets" target="_blank">Authorize access to Google Drive</a>`
            let s = this.state.destinations.gdWorkbooks.find(s => s.id === row.destination.gdWorkbookId)
            if (s && s.name) return `${s.name} → ${row.destination.excelSheetName || ''}!${row.destination.excelCell || ''}`
        } else if (row.destination.type === 'excel') {
            if (!this.state.gotWorkbooks) return `<a href="http://seekwell.io/O365_login" target="_blank">Click here to authorize Excel</a>`
            let s = this.state.destinations.workbooks.find(s => s.id === row.destination.workbookId)
            if (s && s.name) return `${s.name} → ${row.destination.excelSheetName || ''}!${row.destination.excelCell || ''}`
        } else if (row.destination.type === 'sfdc') {
            // let intUrl = 'https://app.intercom.io/oauth?client_id=2666fea1-41de-4aa2-a04d-e155ce8108dc&state=example'
            //let intUrl = this.getPath('/login?ref=sfdc')
            if (!this.state.gotSfdc) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Salesforce</a>`
            return `Salesforce (${row.destination.sfdc.operation} ${row.destination.sfdc.object.name})`
        } else if (row.destination.type === 'intercom') {
            // let intUrl = 'https://app.intercom.io/oauth?client_id=2666fea1-41de-4aa2-a04d-e155ce8108dc&state=example'
            //let intUrl = this.getPath('/login?ref=intercom')
            if (!this.state.gotIntercom) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Intercom</a>`
            return `Intercom (${row.destination.intercom.role} on ${row.destination.intercom.key})`
        } else if (row.destination.type === 'zendesk') {
            //let url = this.getPath('/login?ref=zendesk')
            if (!this.state.integrations) return `Zendesk`
            if (!this.state.integrations.zendesk) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Zendesk</a>`
            return `Zendesk (${row.destination.zendesk.obj} on ${row.destination.zendesk.key})`
        } else if (row.destination.type === 'facebook') {
            // let url = this.getPath('/login?ref=facebook')
            // if (!this.state.integrations.zendesk) return `<a href="${url}" target="_blank">Click here to authorize Zendesk</a>`
            // return `Facebook (${row.destination.zendesk.obj} on ${row.destination.zendesk.key})`
            return `Facebook`
        } else if (row.destination.type === 'hubspot') {
            //let url = this.getPath('/login?ref=hubspot')
            if (!this.state.integrations.hubspot) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Hubspot</a>`
            return `Hubspot (${row.destination.hubspot.operation})`
        } else if (row.destination.type === 'pipedrive') {
            //let url = "https://oauth.pipedrive.com/oauth/authorize?client_id=aba1ed8075f971c0&redirect_uri=http://localhost:8080/pipedrive1"
            //let url = this.getPath('/login?ref=pipedrive')
            if (!this.state.integrations.pipedrive) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Pipedrive</a>`
            return `Pipedrive (${row.destination.pipedrive.operation})`
        }
        else if (row.destination.type === 'servicenow') {
            //let url = this.getPath('/login?ref=servicenow')
            //let url='https://dev78243.service-now.com/oauth_auth.do?client_id=96bd23d1cdd2f01019bb061b797bc2f9&redirect_uri=http://localhost:8081/servicenow1&response_type=code&state=useraccount'
            if (!this.state.integrations.servicenow) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize ServiceNow</a>`
            return `ServiceNow (${row.destination.servicenow.operation})`
        }
        else if (row.destination.type === 'outreach') {
            //let url = this.getPath('/login?ref=outreach')
            if (!this.state.integrations.outreach) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Outreach</a>`
            return `Outreach (${row.destination.outreach.operation})`
        } else if (row.destination.type === 'mailchimp') {
            //let url = this.getPath('/login?ref=mailchimp')
            if (!this.state.integrations.mailchimp) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Mailchimp</a>`
            return `mailchimp (${row.destination.mailchimp.operation})`
        } else if (row.destination.type === 'gainsight') {
            //let url = this.getPath('/login?ref=gainsight')
            //let url='https://dev78243.service-now.com/oauth_auth.do?client_id=96bd23d1cdd2f01019bb061b797bc2f9&redirect_uri=http://localhost:8081/gainsight&response_type=code&state=useraccount'
            if (!this.state.integrations.gainsight) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Gainsight</a>`
            return `Gainsight (${row.destination.gainsight.operation})`
        } else if (row.destination.type === 'blueshift') {
            //let url = this.getPath('/login?ref=blueshift')
            if (!this.state.integrations.blueshift) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Blueshift</a>`
            return `Blueshift (${row.destination.blueshift.obj})`
        } else if (row.destination.type === 'zoho') {
            //let url = this.getPath('/login?ref=zoho')
            if (!this.state.integrations.zoho) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Zoho</a>`
            return `Zoho (${row.destination.zoho.operation})`
        } else if (row.destination.type === 'linkedinAds') {
            //let url = this.getPath('/login?ref=linkedinads')
            if (!this.state.integrations.linkedinads) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize LinkedIn Ads</a>`
            else if (row.destination.linkedinads) return `LinkedIn Ads (${row.destination.linkedinads.operation})`
        } else if (row.destination.type === 'customerio') {
            //let url = this.getPath('/login?ref=customerio')
            if (!this.state.integrations.customerio) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize CustomerIO</a>`
            return `CustomerIO (${row.destination.customerio.operation})`
        } else if (row.destination.type === 'activecampaign') {
            //let url = this.getPath('/login?ref=activecampaign')
            if (!this.state.integrations.activecampaign) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize activecampaign</a>`
            return `ActiveCampaign (${row.destination.activecampaign.operation})`
        } else if (row.destination.type === 'front') {
            //let url = this.getPath('/login?ref=front')
            if (!this.state.integrations.front) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Front</a>`
            return `Front (${row.destination.front.operation})`
        } else if (row.destination.type === 'close') {
            //let url = this.getPath('/login?ref=close')
            if (!this.state.integrations.close) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Close</a>`
            return `Close (${row.destination.close.operation})`
        }
        else if (row.destination.type === 'drift') {
            //let url = this.getPath('/login?ref=drift')
            if (!this.state.integrations.drift) return `<a href="https://app.seekwell.io/integrations" target="_blank">Click here to authorize Drift</a>`
            return `Drift (${row.destination.drift.operation})`
        }
        else if (row.destination.type === 'database') {
            return `Database (${row.destination.database.operation} ${row.destination.database.table})`
        } else if (row.destination.type === 'manual') {
            return `Manual`
        } else if (row.destination.type === 'block') {
            if (row.destination.block && row.destination.block.title) {
                return `<div>${row.destination.block.title}</div>`
            }
            return `<div>Not selected</div>`
        } else if (row.destination.type === 'email') {
            var html = ''
            if (row.destination.emailSource === 'block') {
                var emailSourceBlock = 'Not set'
                if (row.destination.emailSourceBlock && row.destination.emailSourceBlock.title) {
                    emailSourceBlock = row.destination.emailSourceBlock.title
                }
                html = `<div>Email to ${emailSourceBlock}</div>`
            } else if (row.destination.emails) {
                html += `Email to `
                for (let index = 0; index < row.destination.emails.split(',').length; index++) {
                    const element = row.destination.emails.split(',')[index];
                    html += `<span class="dest-email">${element}</span>`
                }
            } else {
                html = `<div>Add an email address</div>`
            }
            return html
        } else if (row.destination.type === 'slack' && Object.entries(this.state.destinations.slack).length === 0) {
            let slackLink = `https://slack.com/oauth/authorize?client_id=274525912167.273518441556&scope=files:read,im:history,channels:history,commands,channels:read,users.profile:read,files:write:user,chat:write:bot,users:read,users:read.email,groups:history,mpim:history,im:read,mpim:read,groups:read,bot`
            return `<a @click="editDestination = true" class="sw-blue" href="${slackLink}" target="_blank">Click here to add our Slack app</a>`
        } else if (row.destination.type === 'slack' && !row.destination.channel) {
            return 'Add destination'
        } else if (row.destination.type === 'slack') {
            return `#${row.destination.channel}`
        } else if (row.destination.type === 'sync') {
            if (!row.destination.table) return 'Add destination'
            return `${row.destination.table} (using ${row.destination.primaryKey} as key)`
        }
        else if (row.destination.type === 'msteams' && this.state.destinations.msteams.ok == false) {
            let msteamsLink = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=ea9b627c-dadf-4d55-91ff-6c4629203cba&response_type=code&redirect_uri=https://seekwell.io/msteams1&response_mode=query&scope=ChatMessage.Send Chat.ReadBasic ChannelMessage.Send Channel.ReadBasic.All Team.ReadBasic.All offline_access&state=12345`
            return `<a @click="editDestination = true" class="sw-blue" href="${msteamsLink}" target="_blank">Click here to add MS Teams app</a>`
        }
        else if (row.destination.type === 'msteams' && this.state.destinations.msteams.ok == true && row.destination.msteams && row.destination.msteams.teamName == '') {
            return `Select a team`
        }
        else if (row.destination.type === 'msteams' && this.state.destinations.msteams.ok == true && row.destination.msteams && row.destination.msteams.teamName != '' && row.destination.msteams.channelName == '') {
            return `Select a channel in the team ${row.destination.msteams.teamName}`
        }
        else if (row.destination.type === 'msteams' && this.state.destinations.msteams.ok == true && row.destination.msteams && row.destination.msteams.teamName != '' && row.destination.msteams.channelName != '') {
            return `MS Teams / ${row.destination.msteams.teamName} / ${row.destination.msteams.channelName}`
        }
        return 'Add destination'
    },
    findHashtags(searchText) {
        var result = searchText.split(' ').filter(v => v.startsWith('#'))
        return result
        // var regexp = /(\s|^)\#\w\w+\b/gm
        // var result = searchText.match(regexp);
        // if (result) {
        //     result = result.map(function(s){ return s.trim();});
        //     return result;
        // } else {
        //     return false;
        // }
    },
    generateStatsSql(opts) {
        let sql = `
        select 
        max(${opts.column}) as "col_max",
        min(${opts.column}) as col_min,
        count(distinct(${opts.column})) as dct,
        sum(case when ${opts.column} is not null then 1 else 0 end) as col_not_null,
        count(${opts.column}) as ct
        from ${opts.table}
        `
        if (opts.type === 'column') {
            sql = `SELECT ${opts.sql.column}, COUNT(1) AS ct FROM ${opts.sql.table} GROUP BY ${opts.sql.column} ORDER BY COUNT(1) DESC LIMIT 100`
        }
        if (opts.type === 'table') {
            sql = `SELECT * FROM ${opts.sql.table} LIMIT 100`
        }
        return sql
    },
    generateMetaSql(opts) {
        var sql = ''
        if (opts.type === 'column') {
            sql = `SELECT ${opts.sql.column}, COUNT(1) AS ct FROM ${opts.sql.table} GROUP BY ${opts.sql.column} ORDER BY COUNT(1) DESC LIMIT 100`
        }
        if (opts.type === 'table') {
            sql = `SELECT * FROM ${opts.sql.table} LIMIT 100`
        }
        return sql
    },
    generateTopTenSql(opts) {
        if (opts.db_type === 'mssql') {
            return `SELECT TOP 10 * FROM ${opts.table}`
        } else {
            return `SELECT * FROM ${opts.table} LIMIT 10`
        }
    },
    generateMetaSql2(opts) {
        var where = ''
        if (opts.filters) {
            for (let i = 0; i < opts.filters.length; i++) {
                let filter = opts.filters[i];
                var andOr = 'AND'
                if (filter.andOr) andOr = filter.andOr.toUpperCase()
                where += ` ${andOr} `
                if (filter.operator.sql.includes('$')) {
                    var w = filter.operator.sql.replace('$field', (filter.field.sql || filter.field.name || filter.field.text))
                    w = w.replace('$value', filter.value)
                    where += ` ${w} `
                } else {
                    where += ` ${filter.field.path} `
                    where += ` ${filter.operator.sql} `
                    if (['int', 'float'].includes(filter.field.python_type)) {
                        where += `${filter.value}`
                    } else {
                        where += `'${filter.value}'`
                    }
                }
            }
        }
        var sql = `select * \nfrom ${opts.table.sql.table}\nwhere 1=1\n${where}\nlimit 100`
        return sql
    },
    generateSetSql(opts) {
        var selectStmnt = ''
        var groupByStmnt = ''
        let dimCt = 0
        let measureLkup = { count: 'COUNT(1)' }
        var where = ''
        if (opts.filters) {
            for (let i = 0; i < opts.filters.length; i++) {
                let filter = opts.filters[i];
                var andOr = 'AND'
                if (filter.andOr) andOr = filter.andOr.toUpperCase()
                where += ` ${andOr} `
                if (filter.operator.period) {
                    var w = filter.operator.sql.replace('$field', (filter.field.sql || filter.field.name))
                    let num = filter.value.num - 1 //something is weird with SQL here, need to subtract 1
                    w = w.replace('$num', num)
                    let period = filter.value.period.slice(0, filter.value.period.length - 1) //remove "s" from period
                    w = w.replace('$period', period)
                    where += ` ${w} `
                } else if (filter.operator.sql.includes('$')) {
                    var w = filter.operator.sql.replace('$field', (filter.field.sql || filter.field.name))
                    w = w.replace('$value', filter.value)
                    w = w.replace('$num', filter.value)
                    where += ` ${w} `
                } else {
                    where += ` ${filter.field.sql || filter.field.name} `
                    where += ` ${filter.operator.sql} `
                    if (filter.field.type === 'number') {
                        where += `${filter.value}`
                    } else {
                        where += `'${filter.value}'`
                    }
                }
            }
        }
        if (opts.setQueryThings) {
            var setSql = this.state.blocks[opts.setQueryThings[0].uuid].code //this needs to be changed when you add JOINs
            this.state.block.setJsonId = opts.setQueryThings[0].setJsonId
            this.state.block.setSqlId = opts.setQueryThings[0].uuid
            var setJson = this.state.blocks[this.state.block.setJsonId].code
            var setMeta = JSON.parse(setJson).fields
            var fields = []
            for (let i = 0; i < opts.setQueryThings.length; i++) {
                let thing = opts.setQueryThings[i];
                thing.setMeta = setMeta[thing.name]
                if (thing.measure) {
                    let measureTypeSql = measureLkup[thing.type]
                    selectStmnt += `${measureTypeSql || thing.sql} as "${thing.label}",\n`
                } else if (thing.type === 'time') {
                    dimCt += 1
                    selectStmnt += `${thing.sql || thing.name} as "${thing.label}",\n`
                    groupByStmnt += `${thing.sql || thing.name},\n`
                } else if (thing.type != 'set') {
                    dimCt += 1
                    selectStmnt += `${thing.sql || key} as "${thing.label}",\n`
                    groupByStmnt += `${thing.name},\n`
                }
            }
        } else { //running from /run for JSON
            var setSql = this.state.blocks[this.state.block.set.sql].code
            var setJson = this.state.block.code
            var setMeta = JSON.parse(setJson).fields
            for (let [key, value] of Object.entries(setMeta)) {
                if (value.measure) {
                    let measureTypeSql = measureLkup[value.type]
                    selectStmnt += `${value.sql || measureTypeSql} as "${value.label}",\n`
                } else if (value.type === 'time') {
                    dimCt += 1
                    selectStmnt += `${value.sql || key} as "${value.label}",\n`
                    groupByStmnt += `${key},\n`
                } else {
                    dimCt += 1
                    selectStmnt += `${value.sql || key} as "${value.label}",\n`
                    groupByStmnt += `${key},\n`
                }
            }
        }
        selectStmnt = selectStmnt.slice(0, selectStmnt.length - 2)
        if (selectStmnt === '') selectStmnt = '*'
        groupByStmnt = groupByStmnt.slice(0, groupByStmnt.length - 2)
        let sql = `select\n${selectStmnt}\nfrom\n(${setSql}) as subsel\nwhere 1=1\n${where}`
        if (dimCt > 0) {
            sql += `\ngroup by\n${groupByStmnt}`
        }
        if (!opts.test) this.state.block.code = sql
        console.log('generateSetSql: ', sql)
        return sql
    },
    cancelRun(opts) {
        this.state.tableLoading = false
    },
    runDataModel(block) {
        console.log('running model...', block.model)
        let data = {
            sessionId: this.state.sessionId,
            email: this.state.settings.user.me.email,
            block: block,
            rowLimit: 10000,
        }
        var self = this
        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                console.log('runDataModel: ', res.data)
                if (!res.data.ok) {
                    console.error('code exec error: ', res.data.error)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    let err = res.data.error.replace('<', '')
                    self.state.message = err
                    return
                }
                self.state.dfHasJson = false
                self.state.dfObjects = []
                if (res.data.df.length > 0) {

                    self.state.dataModel[block.model] = {}
                    self.state.dataModel[block.model].rows = res.data.df
                    let headers = []
                    let cols = Object.keys(res.data.columns)
                    for (let [key, value] of Object.entries(res.data.columns)) {
                        let row = {
                            text: key,
                            align: 'left',
                            sortable: true,
                            value: key,
                            dtype: value.name,
                            kind: value.kind
                        };
                        headers.push(row)
                    }
                    self.state.dataModel[block.model].headers = headers
                }
                if (!localStorage.dataModel) {
                    var lsDataModel = {}
                } else {
                    var lsDataModel = JSON.parse(localStorage.dataModel)
                }
                lsDataModel[block.model] = self.state.dataModel[block.model]
                localStorage.dataModel = JSON.stringify(lsDataModel)
                console.log('MODELSSSSSSS self.state.dataModel: ', self.state.dataModel)
            })
    },
    runDetails(opts) {
        var block = this.state.dataModelBlocks[opts.model]
        block = this.cleanUpBlock(block)
        if (block.params) {
            let params = {}
            for (let i = 0; i < block.params.length; i++) {
                params[block.params[i].name] = this.state.details[block.params[i].name]
            }
            let code = this.interpolate(block.code)(params)
            block.code = code
            console.log('paramd code: ', code)
        }
        let data = {
            sessionId: this.state.sessionId,
            block: block
        }
        var self = this

        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                console.log('runDetails: ', res.data)
                if (!res.data.ok) {
                    console.error('code exec error: ', res.data.error)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    let err = res.data.error.replace('<', '')
                    self.state.message = err
                    return
                }
                if (block.model === 'sessionId') {
                    console.log('got sessionId: ', res.data.df[0])
                    store.state.loading = false
                    store.state.sessionId = res.data.df[0].session_id
                    window.bus.$emit('loginAsDone', { sessionId: store.state.sessionId })
                }
                self.state.dfHasJson = false
                self.state.dfObjects = []
                if (res.data.df.length > 0) {

                    self.state.dataModel[block.model] = {}
                    self.state.dataModel[block.model].rows = res.data.df
                    let headers = []
                    for (let [key, value] of Object.entries(res.data.columns)) {
                        let row = {
                            text: key,
                            align: 'left',
                            sortable: true,
                            value: key,
                            dtype: value.name,
                            kind: value.kind
                        };
                        headers.push(row)
                    }
                    self.state.dataModel[block.model].headers = headers
                    self.state.details.tableHeaders = headers
                    self.state.details.table = res.data.df
                    self.state.details.model = opts.model
                    window.bus.$emit('detailsUpdated', { model: opts.model })
                }
                if (!localStorage.dataModel) {
                    var lsDataModel = {}
                } else {
                    var lsDataModel = JSON.parse(localStorage.dataModel)
                }
                lsDataModel[block.model] = self.state.dataModel[block.model]
                localStorage.dataModel = JSON.stringify(lsDataModel)
                console.log('MODELSSSSSSS self.state.dataModel: ', self.state.dataModel)
            })
    },
    interpolate(str) {
        return function interpolate(o) {
            return str.replace(/{{([^{}]*)}}/g, function (a, b) {
                var r = o[b];
                return typeof r === 'string' || typeof r === 'number' ? r : a;
            });
        }
    },
    getSheetsParamValue(param) {
        let data = {
            sessionId: this.state.sessionId,
            block: this.state.block,
            param: param,
        }
        axios.post(this.getPath('/soup_get_sheets_values'), data)
            .then((res) => {
                console.log('getSheetsParamValue: ', res.data)
                if (!res.data.ok) {
                    console.error('getSheetsParamValue error: ', res.data.error)
                    return
                }
                return res.data
            })
            .catch((error) => {
                console.error('getSheetsParamValue: ', error)
            })
    },
    runTempBlock(block, opts) {
        console.log('runTempBlock: ', block.uuid)
        // this.startTimer(true, block)
        let self = this
        var returnDfJson = true
        if (opts.autoImport) {
            returnDfJson = false
        }
        if (opts.updateDestination) {
            returnDfJson = false
        }
        let data = {
            sessionId: this.state.sessionId,
            block: block,
            test: false,
            rowLimit: opts.rowLimit || 2000,
            returnDfJson: returnDfJson,
        }
        // self.state.tableLoading = true
        block.results.meta.lastRun = moment.unix(moment()).utc()._i
        block.results.meta.runs += 1
        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                // clearInterval(store.state.blocks[block.uuid].codeTimerInterval)
                console.log('runTempBlock done: ', res.data)
                if (opts.runId) {
                    if (self.state.canceledRunIds.filter(i => i.runId === opts.runId).length > 0) {
                        self.state.canceledRunIds = self.state.canceledRunIds.filter(i => i.runId !== opts.runId)
                        return
                    }
                    self.state.runningNowIds = self.state.runningNowIds.filter(i => i.runId !== opts.runId)
                }
                block.results.meta.runTime = moment.unix(moment()).utc()._i - block.results.meta.lastRun
                if (!res.data.ok && !opts.doDestinations) {
                    console.error('code exec error: ', res.data.error)
                    self.state.tableLoading = false;
                    if (opts.showMessage) {
                        self.state.snackbar = true;
                        self.state.message = `Error on ${block.title}: ${res.data.error}`;
                    }
                    return
                }
                if (opts.doDestinations) {
                    self.state.tableLoading = false
                    let sheet = self.state.autoImport.spreadSheetMetadata.sheets.findIndex(s => s.blockId === block.uuid)
                    if (sheet >= 0) {
                        self.state.autoImport.spreadSheetMetadata.sheets[sheet].running = false

                        if (!res.data.ok) {
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].success = false
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].message = `${res.data.error}`
                        } else if (res.data.dbResult && !res.data.dbResult.ok) {
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].success = false
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].message = `${res.data.dbResult.error}`
                        } else {
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].success = true
                            self.state.autoImport.spreadSheetMetadata.sheets[sheet].message = `${res.data.rowCount} rows`
                        }
                        let title = self.state.autoImport.spreadSheetMetadata.sheets[sheet].properties.title
                    }
                    let stillImporting = self.state.autoImport.spreadSheetMetadata.sheets.findIndex(s => (s.running && s.include))
                    if (stillImporting < 0) {
                        self.state.autoImport.running = false
                        self.state.autoImport.success = true
                        // let anySuccess = self.state.autoImport.spreadSheetMetadata.sheets.findIndex(s => (s.success && s.include))
                        // if (anySuccess >= 0) self.state.autoImport.success = true
                    }
                    return
                }
                if (opts.importDb) {
                    self.state.tableLoading = false
                    let source = self.state.autoImport.tables.findIndex(s => s.blockId === block.uuid)
                    if (source >= 0) {
                        self.state.autoImport.tables[source].running = false

                        if (!res.data.ok) {
                            self.state.autoImport.tables[source].success = false
                            self.state.autoImport.tables[source].message = `${res.data.error}`
                        } else if (res.data.sheetResult && !res.data.sheetResult.ok) {
                            self.state.autoImport.tables[source].success = false
                            self.state.autoImport.tables[source].message = `${res.data.sheetResult.error}`
                            if (res.data.sheetResult.error.includes('above the limit of ')) {
                                self.state.autoImport.tables[source].errorType = 'maxCells'
                                self.state.autoImport.tables[source].message = `Google Sheets supports a maximum of 5 million cells.`
                                self.state.autoImport.tables[source].message += ` Reduce the number of cells in your Sheet or edit the SQL.`
                            }
                        } else {
                            self.state.autoImport.tables[source].success = true
                            self.state.autoImport.tables[source].message = `${res.data.rowCount} rows`
                        }
                    }
                    let stillImporting = self.state.autoImport.tables.findIndex(s => (s.running && s.include))
                    if (stillImporting < 0) {
                        self.state.autoImport.running = false
                        self.state.autoImport.success = true
                    }
                    window.bus.$emit('doneTempRun', { ok: true, blockId: block.uuid, opts: { autoImport: true } })
                    return
                }
                self.state.dfHasJson = false
                self.state.dfObjects = []
                if (res.data.df) {
                    self.state.tableExpanded = true
                    if (res.data.df.length > 0) {
                        let firstRow = res.data.df[0]
                        for (let [key, value] of Object.entries(firstRow)) {
                            console.log(key, value);

                            if (typeof (value) == 'object') {
                                self.state.dfHasJson = true
                                self.state.dfObjects.push(key)
                            }
                        }
                    }
                    block.results.rows = Object.freeze(res.data.df)
                    block.results.meta.rows = res.data.df.length
                    let headers = []
                    let cols = Object.keys(res.data.columns)
                    for (let [key, value] of Object.entries(res.data.columns)) {
                        // for (let i = 0; i < cols.length; i++) {
                        let row = {
                            text: key,
                            align: 'left',
                            sortable: true,
                            value: key,
                            dtype: value.name,
                            kind: value.kind
                        };
                        headers.push(row)
                    }
                    block.results.headers = headers
                }
                if (res.data.story && res.data.storyRes && res.data.storyRes.ok && res.data.storyRes.html) {
                    block.story.htmlPreview = res.data.storyRes.html
                    self.updateBlock({ block: block, sliceAt: opts.rowLimit || 2000 })
                }
                if (opts.updateBlock && !res.data.story) {
                    self.updateBlock({ block: block, sliceAt: opts.rowLimit || 2000 })
                    self.state.blocks[block.uuid].results.headers = block.results.headers
                    self.state.blocks[block.uuid].results.rows = block.results.rows
                    self.state.blocks[block.uuid].params = block.params
                    window.bus.$emit('doneTempRun', { ok: true, blockId: block.uuid, opts: opts })
                }
                var cmdkFormHasParam = false
                if (self.state.cmdkForm && opts.updateParamOptions && opts.updateParamOptions.blockId) {
                    let ls = self.state.cmdkForm.params.filter(p => p.blockId === block.uuid)
                    if (ls.length > 0) cmdkFormHasParam = true
                }
                if (opts.updateParamOptions && cmdkFormHasParam) {
                    let pb = self.state.cmdkForm
                    let param = pb.params[opts.updateParamOptions.index]
                    let newOptions = block.results.rows.map(row => row[param.column])
                    self.state.cmdkForm.params[opts.updateParamOptions.index].options = newOptions
                } else if (opts.updateParamOptions && opts.updateParamOptions.blockId) {
                    let pb = self.state.blocks[opts.updateParamOptions.blockId]
                    let param = pb.params[opts.updateParamOptions.index]
                    let newOptions = block.results.rows.map(row => row[param.column])
                    self.state.block.params[opts.updateParamOptions.index].options = newOptions
                    self.updateBlock({ gotBlock: true })
                }
                if (opts.updateFormOptions) {
                    if (block.results.rows.length > 1) {
                        self.state.snackbar = true;
                        self.state.message = 'Look up failed, more than one row found';
                        self.state.tableLoading = false
                        return
                    } else if (block.results.rows.length === 0) {
                        self.state.snackbar = true;
                        self.state.message = 'Look up failed, no rows found';
                        self.state.tableLoading = false
                        return
                    } else {
                        for (let [key, obj] of Object.entries(block.results.rows[0])) {
                            for (let index = 0; index < self.state.blocks[opts.updateFormOptions.blockId].params.length; index++) {
                                const formParam = self.state.blocks[opts.updateFormOptions.blockId].params[index];
                                if (formParam.name === key) {
                                    formParam.value = obj
                                }
                            }
                        }
                    }
                    window.bus.$emit('performedLookup', { ok: true, blockId: opts.updateFormOptions.blockId })
                }

                if (opts.showMessage) {
                    self.state.snackbar = true;
                    self.state.message = `${block.title} run complete.`;
                }
                self.state.tableLoading = false
            })
            .catch((error) => {
                self.state.tableLoading = false
                console.log('runTempBlock error', error)
            })
    },
    runSchemaInfo(block, opts) {
        let self = this
        let data = {
            sessionId: this.state.sessionId,
            block: block,
            test: false
        }
        self.state.browsing.detailsLoading = true
        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                console.log('runSchemaInfo: ', res.data)
                block.results.meta.runTime = moment.unix(moment()).utc()._i - block.results.meta.lastRun
                if (!res.data.ok) {
                    console.error('code exec error: ', res.data.error)
                    self.state.browsing.detailsLoading = false;
                    return
                }
                self.state.browsing.stats = res.data.df[0]
                self.state.browsing.detailsLoading = false
                if (opts.type === 'topTen') {
                    self.state.browsing.results.rows = Object.freeze(res.data.df)
                    let headers = []
                    let cols = Object.keys(res.data.columns)
                    for (let [key, value] of Object.entries(res.data.columns)) {
                        // for (let i = 0; i < cols.length; i++) {
                        let row = {
                            text: key,
                            align: 'left',
                            sortable: true,
                            value: key,
                            dtype: value.name,
                            kind: value.kind
                        };
                        headers.push(row)
                    }
                    self.state.browsing.results.headers = headers
                    self.state.viewNumber = 5
                }
            })
            .catch((error) => {
                self.state.browsing.detailsLoading = false
                console.error('runTempBlock error', error)
            })
    },
    runSet(opts) {
        let self = this
        store.state.showSuggestions = false
        let syncSet = this.state.block.destination.table && this.state.block.destination.primaryKey
        let sheetSet = this.state.block.destination.ss_id && this.state.block.destination.sheet
        if (syncSet && !sheetSet) {
            self.state.snackbar = true;
            self.state.message = 'You need to select a Sheet to sync to';
            self.state.block.destination.type = 'sheets'
            self.showDestination = true
            setTimeout(() => {
                self.$refs.spreadSheets.focus()
            }, 0);
            return
        }
        let block = this.cleanUpBlock(this.state.block)
        if (opts.code) {
            block.code = opts.code
        }
        let data = {
            sessionId: this.state.sessionId,
            block: block,
            test: false
        }
        if (this.state.block.destination.ss_id && !this.state.block.destination.sheet) {
            this.state.block.destination.sheet = 'SeekWellScratch'
            this.state.snackbar = true;
            this.state.message = 'You selected a spreadsheet, but no sheet, added SeekWellScratch';
        }
        self.state.tableLoading = true
        self.state.block.results.meta.lastRun = moment.unix(moment()).utc()._i
        self.state.block.results.meta.runs += 1
        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                console.log('runSet: ', res.data)
                self.state.block.results.meta.runTime = moment.unix(moment()).utc()._i - self.state.block.results.meta.lastRun
                if (!res.data.ok) {
                    console.error('code exec error: ', res.data.error)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    let err = res.data.error.replace('<', '')
                    self.state.message = err
                    return
                }
                if (res.data.notSelect) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Statement executed successfully'
                    if (res.data.rowcount) {
                        self.state.message += `, ${res.data.rowcount} row(s) updated.`
                    }
                    return
                }
                self.state.dfHasJson = false
                self.state.dfObjects = []
                if (res.data.df && res.data.df.length > 0) {
                    self.state.tableExpanded = true
                    let firstRow = res.data.df[0]
                    for (let [key, value] of Object.entries(firstRow)) {
                        console.log(key, value);

                        if (typeof (value) == 'object') {
                            self.state.dfHasJson = true
                            self.state.dfObjects.push(key)
                        }
                    }
                }
                self.state.block.results.rows = res.data.df
                self.state.block.results.meta.rows = res.data.df.length
                let headers = []
                let cols = Object.keys(res.data.columns)
                for (let [key, value] of Object.entries(res.data.columns)) {
                    // for (let i = 0; i < cols.length; i++) {
                    let row = {
                        text: key,
                        align: 'left',
                        sortable: true,
                        value: key,
                        dtype: value.name,
                        kind: value.kind
                    };
                    headers.push(row)
                }
                self.state.block.results.headers = headers

                self.state.tableLoading = false
                self.state.snackbar = true;
                let msg = `${res.data.df.length} rows returned.`;
                if (self.state.block.destination.sheet && res.data.sheetResult.ok) {
                    let sheetUrl = this.getSheetUrl()
                    msg += ` <strong><a style="color: #fff;" href="${sheetUrl}" target="_blank"> Open Sheet</a></strong>`
                } else if (self.state.block.destination.sheet && res.data.sheetResult && !res.data.sheetResult.ok) {
                    console.error('sheet error: ', res.data.sheetResult)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = res.data.sheetResult.reason;
                    return
                }
                self.state.message = msg
                self.state.snackbar = true;

            })
            .catch((error) => {
                self.state.tableLoading = false
                self.state.snackbar = true;
                self.state.message = error;
                console.log('runSet error', error)
            })
    },
    startTimer(reset, block) {
        if (block) {
            block = store.state.blocks[block.uuid]
        } else {
            block = store.state.block
        }
        let start = Date.now()
        let self = this
        if (block.codeTimerInterval > 0) clearInterval(block.codeTimerInterval)
        block.codeTimerInterval = setInterval(function () {
            block.currentRunTime = self.codeTimerFormat(start)
        }, 10);
    },
    codeTimerFormat(jsTimeStamp) {
        var ms = (Date.now() - jsTimeStamp);
        var seconds = (ms / 1000);
        var interval = Math.floor(seconds / 3600);
        if (interval > 1) {
            return (seconds / 3600).toFixed(1) + " hours";
        }
        interval = Math.floor(seconds / 60);
        if (interval > 1) {
            return (seconds / 60).toFixed(1) + "m";
        }
        return (seconds).toFixed(0) + "s";
    },
    deepFreeze(object) {

        // Retrieve the property names defined on object
        var propNames = Object.getOwnPropertyNames(object);

        // Freeze properties before freezing self

        for (let name of propNames) {
            let value = object[name];

            if (value && typeof value === "object") {
                this.deepFreeze(value);
            }
        }

        return Object.freeze(object);
    },
    getErrLineNumAndText(err) {
        var details = {}
        details.lineNumber = false
        if (err.details && err.details.type === 'postgres') {
            details = err.details
            if (err.details.text.includes('LINE ') && err.details.text.includes(':')) {
                details.lineNumber = err.details.text.split('LINE ')[1].split(':')[0]
            }
        } else if (err.details && err.details.type === 'mysql') {
            details = err.details
            if (err.details.text.includes(' at line ')) {
                details.lineNumber = err.details.text.split(' at line ')[1]
            }
        }
        return details
    },
    searchJsonForRgb(content) {
        for (let index = 0; index < content.length; index++) {
            const el = content[index];
            if (el.attrs && el.attrs.background) {
                this.state.block.story.rgbs.push(el.attrs.background)
                break
            }
            if (el.content && el.content.length > 0) {
                this.searchJsonForRgb(el.content)
            }
        }
    },
    runCode(opts) {
        this.startTimer(true, false)
        let self = this
        store.state.showSuggestions = false
        let syncSet = this.state.block.destination.table && this.state.block.destination.primaryKey
        let sheetSet = this.state.block.destination.ss_id && this.state.block.destination.sheet
        if (syncSet && !sheetSet) {
            self.state.snackbar = true;
            self.state.message = 'You need to select a Sheet to sync to';
            self.state.block.destination.type = 'sheets'
            self.showDestination = true
            setTimeout(() => {
                self.$refs.spreadSheets.focus()
            }, 0);
            return
        }
        if (self.state.block.cellType === 'story' && self.state.block.story && self.state.block.story.blocks &&
            self.state.block.story.blocks.length > 0) {
            self.state.block.story.rgbs = []
            for (let index = 0; index < self.state.block.story.json.content.length; index++) {
                const el = self.state.block.story.json.content[index];
                if (el.type === 'table') {
                    this.searchJsonForRgb(el.content)
                    // if (rgb) rgbs.push(rgb)
                }
            }
            self.state.block.story.rgbs = [...new Set(self.state.block.story.rgbs)]
            self.state.block.story.rgbs = self.state.block.story.rgbs.map(r => Number(r.split('.')[1].replace(')', '')))
            self.state.block.story.blocks = self.state.block.story.blocks.filter(o => self.state.block.story.rgbs.includes(o.blockNum))
        }
        if (this.state.block.destination.ss_id && !this.state.block.destination.sheet) {
            this.state.block.destination.sheet = 'SeekWellScratch'
            this.state.snackbar = true;
            this.state.message = 'You selected a spreadsheet, but no sheet, added SeekWellScratch';
        }

        let block = this.cleanUpBlock(this.state.block)
        if (opts.pauseDestination) {
            block.destination = this.state.blockTemplate.destination
        }
        if (block.params) {
            let params = {}
            for (let i = 0; i < block.params.length; i++) {
                if (block.params[i].type === 'sheets') {
                    if (!block.params[i].spreadSheet) {
                        self.state.snackbar = true;
                        self.state.message = `You need to set the Spreadsheet for ${block.params[i].name}`;
                        window.bus.$emit('focusRef', { ref: `param_spreadsheet_${i}` })

                        return
                    }
                    if (!block.params[i].sheet) {
                        self.state.snackbar = true;
                        self.state.message = `You need to set the Sheet for ${block.params[i].name}`;
                        window.bus.$emit('focusRef', { ref: `param_sheet_${i}` })
                        return
                    }
                    // let sheetValues = this.getSheetsParamValue(block.params[i])
                    // params[block.params[i].name] = block.params[i].value
                } else if (['file', 'block', 'excel'].includes(block.params[i].type) && block.cellType != 'python') {
                    block.cellType = 'sheetsAsSql'
                    block.source = {
                        name: 'Sheets / File / API',
                        uuid: 'googlesheets',
                        type: 'sheets',
                        meta: false,
                        db_type: 'Sheets / File / API',
                        spreadsheetId: false,
                        sheets: [],
                        unique_source: 1,
                        block_uuid: 'googlesheets',
                    }
                    //pass?
                } else if (['file', 'block', 'excel'].includes(block.params[i].type) && block.cellType === 'python') {
                    //pass?
                } else if (block.params[i].type === 'subquery') {
                    //pass
                } else if (block.params[i].type === 'lookup') {
                    //pass
                } else if ('default' in block.params[i] && block.params[i].default != 'required') {
                    //pass
                } else if (!block.params[i].value) {
                    self.state.snackbar = true;
                    self.state.message = `You need to set ${block.params[i].name}`;
                    window.bus.$emit('focusRef', { ref: `param_${block.params[i].name}` })
                    return
                } else {
                    params[block.params[i].name] = block.params[i].value
                }
            }
        }
        let data = {
            sessionId: this.state.sessionId,
            email: this.state.settings.user.me.email,
            block: block,
            test: opts.test || false,
            public: opts.public || false,
        }
        self.state.tableLoading = true
        self.state.block.results.meta.lastRun = moment.unix(moment()).utc()._i
        self.state.block.results.meta.runs += 1
        self.state.dbError = false
        // remove table blocks that have been deleted from the story

        axios.post(this.getPathRunner('/run_one'), data)
            .then((res) => {
                clearInterval(self.state.block.codeTimerInterval)
                console.log('runCode: ', res.data)
                self.state.block.results.meta.runTime = moment.unix(moment()).utc()._i - self.state.block.results.meta.lastRun

                if (!res.data.ok) {
                    console.error('code exec error: ', res.data.error)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    let errDetails = this.getErrLineNumAndText(res.data)
                    var err = res.data.error.replace('<', '')
                    if (err.length > 400) {
                        err = err.slice(0, 200) + '\n...\n' + err.slice(err.length - 200)
                    }
                    self.state.message = err
                    self.state.dbError = err
                    if (errDetails.lineNumber && !isNaN(errDetails.lineNumber) && window.editor) {
                        self.state.errLineNum = Number(errDetails.lineNumber) - 1
                        window.editor.addLineClass(self.state.errLineNum, 'background', 'tw-bg-red-200');
                        window.editor.doc.setCursor({ line: self.state.errLineNum, ch: 0 })
                        setTimeout(() => {
                            window.editor.removeLineClass(self.state.errLineNum, 'background', 'tw-bg-red-200');
                        }, 10000);
                    }
                    return
                }
                if (self.state.errLineNum >= 0 && window.editor) {
                    window.editor.removeLineClass(self.state.errLineNum, 'background', 'tw-bg-red-200');
                }
                if (res.data.notSelect) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Statement executed successfully'
                    if (res.data.rowcount) {
                        self.state.message += `, ${res.data.rowcount} row(s) updated.`
                    }
                    return
                }
                if (res.data.triggerStoppedRun) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Statement executed successfully, but trigger condition not met'
                    if (res.data.rowcount) {
                        self.state.message += `, ${res.data.rowcount} row(s) updated.`
                    }
                    return
                }
                if (res.data.story && res.data.storyRes && !res.data.storyRes.ok) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Failed to write a Story 🤔'
                    return
                }
                if (res.data.story && res.data.storyRes && res.data.storyRes.ok && res.data.storyRes.html) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Story written ✍️ successfully!'
                    window.bus.$emit('doneStoryRun', { ok: true, html: res.data.storyRes.html })
                    return
                }
                if (res.data.story) {
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = 'Story written ✍️ successfully!'
                    return
                }


                self.state.dfHasJson = false
                self.state.dfObjects = []
                if (res.data.df && res.data.df.length > 0) {
                    self.state.tableExpanded = true
                    let firstRow = res.data.df[0]
                    for (let [key, value] of Object.entries(firstRow)) {
                        console.log(key, value);

                        if (typeof (value) == 'object') {
                            self.state.dfHasJson = true
                            self.state.dfObjects.push(key)
                        }
                    }
                }

                if (res.data.pyResult && res.data.pyResult.ok && !res.data.pyResult.dfNames) {
                    self.state.message = `Done run, no data returned`
                    self.state.snackbar = true;
                    self.state.tableLoading = false
                    return
                }
                self.state.allRows = Object.freeze(res.data.df)
                window.bus.$emit('doneRun', { ok: true })
                if (res.data.df.length > 0 && self.state.viewNumber === 2) {
                    self.state.returnToZen = true
                    self.state.viewNumber = 1
                }
                self.state.block.results.rows = self.state.allRows.slice(0, 100)
                // self.state.block.results.rows = res.data.df.map(d => Object.freeze(d))
                self.state.block.results.meta.rows = res.data.df.length
                if (res.data.rowCount) self.state.block.results.meta.rows = res.data.rowCount
                let headers = []
                let cols = Object.keys(res.data.columns)
                for (let [key, value] of Object.entries(res.data.columns)) {
                    // for (let i = 0; i < cols.length; i++) {
                    let row = {
                        text: key,
                        align: 'left',
                        sortable: true,
                        value: key,
                        dtype: value.name,
                        kind: value.kind
                    };
                    headers.push(row)
                }
                self.state.block.results.headers = headers
                self.state.block.results.stats = res.data.stats
                self.state.tableLoading = false
                self.state.snackbar = true;
                let msg = `${res.data.df.length} rows returned.`;
                self.state.message = msg
                if (self.state.block.destination.sheet && res.data.sheetResult.ok) {
                    let sheetUrl = this.getSheetUrl()
                    msg += ` <strong><a style="color: #fff;" href="${sheetUrl}" target="_blank"> Open Sheet</a></strong>`
                } else if (self.state.block.destination.sheet && res.data.sheetResult && !res.data.sheetResult.ok) {
                    console.error('sheet error: ', res.data.sheetResult)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = res.data.sheetResult.reason;
                    self.state.dbError = `${res.data.sheetResult.reason} - ${res.data.sheetResult.error}`
                    return
                } else if (self.state.block.destination.gdWorkbookId && res.data.excelResult && !res.data.excelResult.ok) {
                    console.error('excel error: ', res.data.sheetResult)
                    self.state.tableLoading = false;
                    self.state.snackbar = true;
                    self.state.message = res.data.excelResult.error;
                    self.state.dbError = `${res.data.excelResult.error}`
                    return
                } else if (!res.data.intercomResult.ok) {
                    self.state.dbError = `Intercom update error: ${res.data.intercomResult.error}`
                    return
                } else if (self.state.block.destination.type === 'facebook' &&
                    self.state.block.destination.facebook.createAudience) {
                    self.state.integrations.facebook.accounts.data.filter(a => a.account_id === self.state.block.destination.facebook.account_id)[0].audiences.data.push(res.data.facebookResult.audience)
                    self.state.block.destination.facebook.createAudience = false
                    self.state.block.destination.facebook.audience = res.data.facebookResult.audience
                    msg = `Facebook Audience created.`
                    return
                } else if (!res.data.sfdcResult.ok) {
                    self.state.dbError = `Salesforce update error: ${res.data.sfdcResult.error}`
                    return
                } else if (!res.data.zendeskResult.ok) {
                    self.state.dbError = `Zendesk update error: ${res.data.zendeskResult.error}`
                    return
                } else if (!res.data.hubspotResult.ok) {
                    self.state.dbError = `Hubspot update error: ${res.data.hubspotResult.error}`
                    return
                } else if (!res.data.pipedriveResult.ok) {
                    self.state.dbError = `Pipedrive update error: ${res.data.pipedriveResult.error}`
                    return
                } else if (!res.data.servicenowResult.ok) {
                    self.state.dbError = `ServiceNow update error: ${res.data.servicenowResult.error}`
                    return
                } else if (!res.data.outreachResult.ok) {
                    self.state.dbError = `Outreach update error: ${res.data.outreachResult.error}`
                    return
                } else if (!res.data.zohoResult.ok) {
                    self.state.dbError = `Zoho update error: ${res.data.zohoResult.error}`
                    return
                } else if (!res.data.linkedinadsResult.ok) {
                    self.state.dbError = `linkedinadsResult update error: ${res.data.linkedinadsResult.error}`
                    return
                } else if (!res.data.gainsightResult.ok) {
                    self.state.dbError = `Gainsight update error: ${res.data.gainsightResult.error}`
                    return
                } else if (!res.data.customerioResult.ok) {
                    self.state.dbError = `CustomerIO update error: ${res.data.customerioResult.error}`
                    return
                } else if (!res.data.activecampaignResult.ok) {
                    self.state.dbError = `ActiveCampaign update error: ${res.data.activecampaignResult.error}`
                    return
                } else if (!res.data.mailchimpResult.ok) {
                    self.state.dbError = `Mailchimp update error: ${res.data.mailchimpResult.error}`
                    return
                } else if (!res.data.frontResult.ok) {
                    self.state.dbError = `Front operation error: ${res.data.frontResult.error}`
                    return
                } else if (!res.data.driftResult.ok) {
                    self.state.dbError = `Drift operation error: ${res.data.driftResult.error}`
                } else if (!res.data.closeResult.ok) {
                    self.state.dbError = `Close operation error: ${res.data.closeResult.error}`
                    return
                } else if (res.data.intercomResult.ok && res.data.intercomResult.status) {
                    msg += ` ${res.data.intercomResult.status}`
                } else if (self.state.block.destination.type === 'sfdc') {
                    let hasSfdcId = headers.find(h => h.text.toLowerCase() === 'id')
                    if (!hasSfdcId && !['insert', 'upsert'].includes(self.state.block.destination.sfdc.operation)) {
                        self.state.dbError = `Salesforce update error: You did not include an Id to update your Object`
                    }
                } else if (!res.data.dbResult.ok) {
                    self.state.dbError = `Database update error: ${res.data.dbResult.error}`
                    return
                } else if (!res.data.msteamsError.ok) {
                    self.state.dbError = `MS Teams error: ${res.data.msteamsError.message}`
                    return
                }
                self.state.message = msg
                self.state.snackbar = true;
                if (res.data.pyResult && res.data.pyResult.ok && res.data.pyResult.dfNames) {
                    self.state.block.python.dfNames = res.data.pyResult.dfNames
                }
            })
            .catch((error) => {
                window.Sentry.captureException(error)
                self.state.tableLoading = false
                self.state.snackbar = true;
                self.state.message = error;
                console.log('runCode error', error)
            })
    },
};
